module.exports    = {
	"language": "Sprache",
	"hello": "Hallo {{.a}}",
	"c001": "Zeitüberschreitung des Dienstes. Bitte versuchen Sie es später erneut!",
	"c002": "Beenden",
	"c003": "Anmelden",
	"c004": "Benutzernamen eingeben",
	"c005": "Anmeldepasswort eingeben",
	"c006": "Speichern",
	"c007": "Der Benutzername oder das Passwort ist falsch.",
	"c008": "Benutzerkonto",
	"c009": "Sprache",
	"c010": "Gesamt",
	"c011": "Datensätze",
	"c012": "Hallo,",
	"c013": "Ihr Benutzerkonto ist nicht aktiviert. Wenden Sie sich an den Administrator.",
	"c014": "Ihr Benutzerkonto ist gesperrt. Wenden Sie sich an den Administrator.",
	"c015": "Zurücksetzen",
	"c016": "WebSocket-Verbindung fehlgeschlagen.",
	"c017": "Interner Fehler",
	"c018": "Sie sind nicht berechtigt, diesen Vorgang auszuführen.",
	"c019": "Der aktuelle Benutzer ist nicht berechtigt, diese Seite anzuzeigen.",
	"c020": "Ihre Anmeldesitzung ist abgelaufen. Melden Sie sich erneut an!",
	"c021": "Benutzeranmeldung",
	"c022": "Dokumentation",
	"c023": "In Ordnung",
	"c024": "Nicht in Ordnung",
	"c025": "Ergebnis",
	"c026": "System",
	"c027": "Datenbankverbindungsfehler. Prüfen Sie die Datenbankverbindung.",
	"c028": "Fehler bei der Datenbankinitialisierung. Prüfen Sie die Datenbank.",
	"m001": "Offline",
	"m002": "Online",
	"m003": "Störung",
	"m004": "Gelöscht",
	"m005": "Gerät hinzufügen",
	"m006": "Gerät bearbeiten",
	"m007": "Geräteverwaltung",
	"m008": "Nr.",
	"m009": "Status",
	"m010": "Geräte-ID",
	"m011": "Gerätename",
	"m012": "Zugeordneter Bereich",
	"m013": "Sortierreihenfolge",
	"m014": "IP-Adresse",
	"m015": "Kommunikationsadresse",
	"m016": "Bemerkungen",
	"m017": "Aktualisiert am",
	"m018": "Aktionen",
	"m019": "Bearbeiten",
	"m020": "Gerät erfolgreich aktualisiert.",
	"m021": "Gerät erfolgreich hinzugefügt.",
	"m022": "Gerätename, Geräte-ID oder IP-Adresse ist bereits vorhanden.",
	"m023": "Der Gerätename ist erforderlich und muss mindestens 2 Zeichen enthalten.",
	"m024": "Die Geräte-ID ist erforderlich und muss mindestens 2 Zeichen enthalten.",
	"m025": "Die IP-Adresse ist erforderlich.",
	"m026": "Der Port muss eine Ganzzahl mit höchstens 5 Stellen sein.",
	"m027": "Löschen",
	"m028": "Wiederherstellen",
	"m029": "Port",
	"m030": "Automatische Verbindung aktivieren",
	"m031": "Hinweis: Die Kommunikationsadresse muss mit der im Programmiergerät der Schweißsteuerung eingestellten Adresse übereinstimmen.",
	"m032": "Alle Bereiche",
	"m033": "Alle Status",
	"m034": "Auswählen",
	"m035": "Online",
	"m036": "Offline",
	"m037": "Beim Löschen des Geräts ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"m038": "Beim Wiederherstellen des Geräts ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"m039": "Gerät erfolgreich gelöscht.",
	"m040": "Gerät erfolgreich wiederhergestellt.",
	"m041": "Beim Abrufen der Gerätedaten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"m042": "Ungültiges IP-Adressformat.",
	"m043": "Die Kommunikationsadresse muss eine Ganzzahl mit höchstens 5 Stellen sein.",
	"m044": "Wählen Sie einen Bereich aus.",
	"m045": "Gerät konnte nicht aktualisiert werden.",
	"m046": "Gerät konnte nicht hinzugefügt werden.",
	"m047": "Der Gerätename ist bereits vorhanden. Geben Sie einen anderen Namen ein.",
	"m048": "Die Geräte-ID ist bereits vorhanden. Geben Sie eine andere ID ein.",
	"m049": "Die IP-Adresse ist bereits vorhanden. Geben Sie eine andere Adresse ein.",
	"m050": "Stromkurve erfassen",
	"m051": "Spannungskurve erfassen",
	"m052": "Widerstandskurve erfassen",
	"m053": "Kraftkurve erfassen",
	"m054": "Automatische Verbindung",
	"m055": "Fehler beim Auswerten der Importdatei.",
	"m056": "Fehler beim Lesen der hochgeladenen Datei.",
	"m057": "Ungültige Dateierweiterung (.xlsx, .xlsm oder .xltx erforderlich).",
	"m058": "Die Datei ist zu groß (maximal 10 MB).",
	"m059": "Gerät",
	"m060": "Feld",
	"m061": "Import abgeschlossen: {{.a}} Datensätze importiert, davon {{.b}} neu oder aktualisiert.",
	"m062": "Import fehlgeschlagen.",
	"m063": "Schließen",
	"m064": "Dasselbe Schweißprogramm kann nicht mit sich selbst verglichen werden.",
	"m065": "Fehler beim Abfragen der Steuerungsliste.",
	"m066": "Diese Dateierweiterung ist nicht zulässig.",
	"m067": "Falsches Passwort. Geben Sie es erneut ein.",
	"m068": "Upgrade erfolgreich abgeschlossen.",
	"m069": "Steuerung auf Werkseinstellungen zurücksetzen?",
	"m070": "Es wird nur Gerätetyp 803 unterstützt.",
	"m071": "Das System verarbeitet die Anforderung. Bitte warten.",
	"m072": "Aufgabe erfolgreich hinzugefügt und wird verarbeitet.",
	"m073": "Beim Import werden die vorhandenen Daten überschrieben. Fortfahren?",
	"m074": "Fehler beim Schreiben der Datei.",
	"m075": "Gerätename / Geräte-ID / IP-Adresse / Bemerkungen / MAC-Adresse suchen",
	"m076": "Alle verbinden",
	"m077": "Alle trennen",
	"m078": "Alle Geräte wurden erfolgreich verbunden.",
	"m079": "Alle Geräte wurden erfolgreich getrennt.",
	"m080": "Nicht alle Geräte konnten verbunden werden.",
	"m081": "Nicht alle Geräte konnten getrennt werden.",
	"m082": "Excel-Arbeitsmappe konnte nicht erstellt werden.",
	"m083": "Deserialisierungsfehler der Schweißkurve.",
	"m084": "Fehler beim Abrufen der Alarmdatensätze.",
	"m085": "Fehler beim Schreiben von Systemparametersatz 1.",
	"m086": "Fehler beim Schreiben von Systemparametersatz 2.",
	"m087": "Fehler beim Schreiben von Systemparametersatz 3.",
	"m088": "Nicht gefunden. Fügen Sie zuerst den entsprechenden Bereich hinzu.",
	"m089": "Geräte gesamt",
	"m090": "Neu verbinden",
	"m091": "Sichern",
	"m092": "Schweißprogrammparameter",
	"m093": "Systemparameter",
	"m094": "Es sind keine Geräte ausgewählt!",
	"m095": "Es sind keine Parameter für die Sicherung ausgewählt!",
	"m096": "Die Stapelsicherung läuft. Bitte warten.",
	"m097": "Die Sicherung ist nicht vorhanden!",
	"m098": "Fehler beim Packen der Sicherung!",
	"m099": "Stapelsicherung abgeschlossen. Laden Sie das Sicherungspaket herunter.",
	"m100": "TAR-Archiv konnte nicht erstellt werden.",
	"m101": "Pfad konnte nicht ermittelt werden.",
	"m102": "Sicherung erfolgreich abgeschlossen.",
	"m103": "Wählen Sie die Upgrade-Datei aus.",
	"m104": "Geräte-Upgrade",
	"m105": "Während des Upgrades ist ein Fehler aufgetreten.",
	"m106": "Die Firmwaredaten sind leer. Das Upgrade kann nicht durchgeführt werden.",
	"m107": "Verbindung mit Gerät „{{.a}}“ nicht möglich. Prüfen Sie die Verbindung. Falls das Problem weiterhin besteht, starten Sie das Gerät neu.",
	"m108": "Die ausgewählte Datei ist kein gültiges Upgrade-Paket.",
	"m109": "Startpaket konnte nicht gesendet werden.",
	"m110": "Ungültige Antwort auf das Startpaket.",
	"m111": "Fehler beim Senden des Datenpakets an Paketposition „{{.a}}“.",
	"m112": "Fehler beim Empfangen des Datenpakets an Paketposition „{{.a}}“.",
	"m113": "Fehler beim Senden des Endpakets.",
	"m114": "Fehler beim Empfangen der Antwort auf das Endpaket.",
	"m115": "Das Gerät wird aktualisiert. Bitte warten.",
	"m116": "Geräte-Upgrade läuft",
	"m117": "Geräte-Upgrade erfolgreich abgeschlossen.",
	"m118": "Geräte-Upgrade fehlgeschlagen.",
	"m119": "Erneut versuchen",
	"m120": "Warten auf Start",
	"m121": "Übersicht des Upgrade-Fortschritts",
	"m122": "Erfolgreich:",
	"m123": "Fehlgeschlagen",
	"m124": "In Bearbeitung",
	"m125": "Details zum Geräte-Upgrade",
	"m126": "Die Firmwaredatei ging beim Aktualisieren der Seite verloren; das Upgrade kann daher nicht erneut versucht werden.",
	"m127": "Sonstige",
	"m128": "Upgrade abgebrochen.",
	"m129": "Abbruch läuft ...",
	"m130": "Durch Abbrechen des Upgrades werden alle weiteren Geräte nicht mehr aktualisiert. Fortfahren?",
	"m131": "Online-Geräte",
	"m132": "Offline-Geräte",
	"m133": "Geräte neu verbinden",
	"m134": "Gerätename / Geräte-ID / IP",
	"m135": "Keine passenden Geräte gefunden.",
	"m136": "Derzeit sind keine Geräte für diesen Vorgang verfügbar.",
	"m137": "Geräte-ID",
	"m138": "Ursprüngliche Softwareversion der Steuerung",
	"m139": "Download fehlgeschlagen. Keine passenden Daten gefunden.",
	"m140": "Vorgangsergebnis",
	"m141": "Gerätetyp",
	"m142": "Wählen Sie einen Gerätetyp aus.",
	"m143": "Dieser Gerätetyp ist für Ihre Softwareversion nicht aktiviert. Wenden Sie sich zur Aktivierung an den Hersteller.",
	"m144": "HRC-803 Mittelfrequenz-Schweißmaschine",
	"m145": "HRC-802",
	"m146": "HRC-A50",
	"m147": "HRC-501",
	"m148": "HRC-650 Schweißqualitätsmonitor",
	"m149": "HRC-670 Nietqualitätsmonitor",
	"m150": "HRC-62 Wechselstrom-Schweißmaschine",
	"m151": "Aktueller Aktivierungscode",
	"m152": "Parametersicherung",
	"m153": "Parameterwiederherstellung",
	"m154": "Geräte importieren",
	"m155": "Alle Geräte exportieren",
	"m156": "Die Sicherung der Geräteparameter läuft. Bitte warten.",
	"m157": "Parametersicherung abgebrochen.",
	"m158": "Sicherungsverzeichnis konnte nicht erstellt werden. Parametersicherung fehlgeschlagen.",
	"m159": "Während der Sicherung ist ein Fehler aufgetreten. Parametersicherung fehlgeschlagen.",
	"m160": "Schweißprogrammdaten konnten nicht gelesen werden. Parametersicherung fehlgeschlagen.",
	"m161": "Excel-Arbeitsmappe konnte nicht erstellt werden. Parametersicherung fehlgeschlagen.",
	"m162": "Systemparameter konnten nicht gelesen werden. Parametersicherung fehlgeschlagen.",
	"m163": "Das Gerät ist offline. Parametersicherung fehlgeschlagen.",
	"m164": "Übersicht des Fortschritts der Parametersicherung",
	"m165": "Details zur Parametersicherung",
	"m166": "Geräteparameter werden gesichert",
	"m167": "Parametersicherung erfolgreich abgeschlossen.",
	"m168": "Parametersicherung fehlgeschlagen.",
	"m169": "Schweißprogrammparameter sichern",
	"m170": "Fortschritt der Sicherung der Schweißprogrammparameter",
	"m171": "Fortschritt der Sicherung der Systemparameter",
	"m172": "Fortschritt der Sicherung der Schweißpunktinformationen",
	"m173": "Die Aufgabe zum erneuten Upgrade wurde gestartet.",
	"m174": "Die Aufgabe zur erneuten Sicherung wurde gestartet.",
	"m175": "Die Aufgabe zum Abbrechen des Upgrades wurde gestartet.",
	"m176": "Die Aufgabe zum Abbrechen der Sicherung wurde gestartet.",
	"m177": "Durch Abbrechen der Sicherung werden alle weiteren Geräte nicht mehr gesichert. Fortfahren?",
	"m178": "Wählen Sie ein TAR-Archiv aus.",
	"m179": "Fehler beim Entpacken des Archivs. Prüfen Sie, ob die Datei gültig ist.",
	"m180": "Parameterwiederherstellung abgeschlossen.",
	"m181": "Während der Parameterwiederherstellung ist ein Fehler aufgetreten.",
	"m182": "Übersicht des Fortschritts der Parameterwiederherstellung",
	"m183": "Details zur Parameterwiederherstellung",
	"m184": "Geräteparameter werden wiederhergestellt",
	"m185": "Parameterwiederherstellung erfolgreich abgeschlossen.",
	"m186": "Parameterwiederherstellung fehlgeschlagen.",
	"m187": "Fortschritt der Wiederherstellung der Schweißprogrammparameter",
	"m188": "Fortschritt der Wiederherstellung der Systemparameter",
	"m189": "Fortschritt der Wiederherstellung der Schweißpunktinformationen",
	"m190": "Fehler beim Importieren der Schweißpunktinformationen.",
	"m191": "Sicherung abgebrochen.",
	"m192": "Parameterwiederherstellung abgebrochen.",
	"m193": "Auf dem Gerät läuft eine Sicherungs- oder Wiederherstellungsaufgabe. Ein Download ist nicht möglich.",
	"m194": "Durch Abbrechen der Parameterwiederherstellung werden alle weiteren Geräte nicht mehr wiederhergestellt. Fortfahren?",
	"m195": "Das entsprechende Gerät wurde im Archiv nicht gefunden. Prüfen Sie die Datei.",
	"m196": "Die Aufgabe zur erneuten Parameterwiederherstellung wurde gestartet.",
	"m197": "Auf dem Gerät läuft eine andere Aufgabe. Dieser Vorgang ist nicht verfügbar.",
	"m198": "Wiederherzustellende Parameter:",
	"m199": "In Ihren Aktivierungsinformationen ist kein Gerätetyp aktiviert; Geräte können daher derzeit nicht hinzugefügt oder geändert werden.",
	"m200": "Dieser Vorgang wird für dieses Gerät derzeit nicht unterstützt.",
	"m201": "Sicherungsdatei",
	"m202": "Die Importdatei stimmt nicht mit der Geräte-ID oder dem Gerätetyp überein. Das Dateinamenpräfix muss lauten: Geräte-ID + {{.a}}",
	"m203": "Anmeldepasswort",
	"m204": "Wählen Sie eine Datei aus.",
	"m205": "Gelöschte Daten können nicht wiederhergestellt werden. Daten löschen?",
	"m206": "Sicherungen löschen",
	"m207": "Löschen",
	"m208": "Erfolgreich gelöscht.",
	"m209": "Löschen fehlgeschlagen.",
	"m210": "Doppelte Geräte-MAC-Adresse.",
	"m211": "Benutzer „{{.a}}“ hat die Parameter des Geräts „{{.b}}“ gesichert:",
	"m212": "Das aktuelle Gerät ist bereits geöffnet. Ein doppelter Vorgang ist nicht zulässig.",
	"m213": "MAC-Adresse",
	"m214": "Austreibungsstelle",
	"m215": "Hilfe",
	"m216": "Bereich trennen",
	"m217": "Bereich verbinden",
	"p001": "Bereich anlegen",
	"p002": "Bereich bearbeiten",
	"p003": "Der Bereich wird verwendet und kann nicht gelöscht werden.",
	"p004": "Bereichsverwaltung",
	"p005": "Bereichsname",
	"p006": "Bereichsbemerkungen",
	"p007": "Bereich erfolgreich aktualisiert.",
	"p008": "Bereich erfolgreich hinzugefügt.",
	"p009": "Doppelter Bereichsname.",
	"p010": "Der Bereichsname ist erforderlich und muss mindestens 2 Zeichen enthalten.",
	"p011": "Die Sortierreihenfolge muss eine positive Ganzzahl mit höchstens 5 Stellen sein.",
	"p012": "Ungültige Seitennavigationsparameter.",
	"p013": "Beim Abrufen der Bereichsdaten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"p014": "Die Eingabe-ID ist ungültig und muss eine Ganzzahl sein.",
	"p015": "Fehler beim Übermitteln der Daten.",
	"p016": "Der Bereichsname ist bereits vorhanden. Ändern Sie ihn und senden Sie erneut.",
	"p017": "Beim Hinzufügen des Bereichs ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"p018": "Beim Aktualisieren des Bereichs ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"p019": "Beim Prüfen, ob der Bereich verwendet wird, ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"p020": "Beim Löschen des Bereichs ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"p021": "Beim Wiederherstellen des Bereichs ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"p022": "Bereich erfolgreich gelöscht.",
	"p023": "Bereich erfolgreich wiederhergestellt.",
	"p024": "Datensätze/Seite",
	"p025": "Schweißprogramm-Nr. vor dem Elektrodenkappenfräsen",
	"p026": "Schweißprogramm-Nr. nach dem Elektrodenkappenfräsen",
	"p027": "Keine Daten verfügbar.",
	"p028": "Referenzkurve speichern",
	"p029": "Dieser Datensatz enthält keine Widerstandskurvendaten.",
	"p030": "Widerstandskurven vor und nach dem Elektrodenkappenfräsen abfragen",
	"p031": "Die Kurvendatenlängen vor und nach dem Elektrodenkappenfräsen stimmen nicht überein. Eine Auswahl ist nicht möglich.",
	"p032": "Dieser Datensatz enthält keine Widerstandskurve.",
	"p033": "Die Länge der ausgewählten Kurve stimmt nicht mit der aktuellen Diagrammlänge überein. Eine Auswahl ist nicht möglich.",
	"p034": "Vor dem Elektrodenkappenfräsen",
	"p035": "Nach dem Elektrodenkappenfräsen",
	"p036": "Wählen Sie zuerst einen Kurvendatensatz aus.",
	"p037": "Der ausgewählte Datensatz enthält keine Widerstandskurvendaten.",
	"p038": "[Referenzkurve] Vor dem Elektrodenkappenfräsen",
	"p039": "[Referenzkurve] Nach dem Elektrodenkappenfräsen",
	"p040": "Erzeugen Sie zuerst eine Referenzkurve.",
	"p041": "Referenzkurve erfolgreich gespeichert.",
	"p042": "Fehler beim Abfragen der Referenzkurvendatensätze.",
	"p043": "Ungültige Kurvendaten.",
	"p044": "Die Kurve liegt außerhalb des zulässigen Schwankungsbereichs der gespeicherten Referenzkurve und kann nicht erzeugt werden.",
	"p045": "Echtzeitkurve und Referenzkurve haben unterschiedliche Längen.",
	"p046": "Die Echtzeitkurve nach dem Elektrodenkappenfräsen liegt außerhalb des Toleranzbereichs.",
	"p047": "Einstellungen für Elektrodenkappenfräsen",
	"p048": "Einstellungen für Elektrodenkappenfräsen anzeigen",
	"p049": "Einstellungen für Elektrodenkappenfräsen verwalten",
	"p050": "Überwachung des Elektrodenkappenfräsens",
	"p051": "Überwachung des Elektrodenkappenfräsens anzeigen",
	"p052": "Überwachung des Elektrodenkappenfräsens verwalten",
	"p053": "Schwankungsbereich zum Speichern der Referenzkurve",
	"p054": "Schwankungsbereich zur Überwachung der Referenzkurve",
	"p055": "Alarmtyp",
	"p056": "Anzeigen",
	"p057": "[Echtzeitkurve] Vor dem Elektrodenkappenfräsen",
	"p058": "[Echtzeitkurve] Nach dem Elektrodenkappenfräsen",
	"p059": "Aktuelle Referenz-Widerstandskurve",
	"p060": "Referenz-Widerstandskurve",
	"p061": "Widerstandskurve in Vorschau anzeigen",
	"p062": "Der Widerstand nach dem Elektrodenkappenfräsen ist größer als davor.",
	"p063": "Die obere und untere Toleranz für die automatische Aussonderung müssen größer als 0 sein.",
	"p064": "Obere und untere Toleranz für automatische Aussonderung",
	"p065": "Einstellungen zur Überwachung der Schweißwiderstandskurve",
	"p066": "Vorfilterung aktivieren",
	"p067": "Mittlerer Widerstand vor dem Elektrodenkappenfräsen minus mittlerer Widerstand danach ist größer als",
	"p068": "Als normal einstufen",
	"p069": "Das System hat Kurven außerhalb des Toleranzbereichs automatisch entfernt.",
	"p070": "Obere Toleranz der Kurve nach dem Elektrodenkappenfräsen",
	"p071": "Untere Toleranz der Kurve nach dem Elektrodenkappenfräsen",
	"p072": "Geben Sie die Schweißprogrammnummern vor und nach dem Elektrodenkappenfräsen ein.",
	"p073": "Der Widerstand vor dem Elektrodenkappenfräsen minus dem Widerstand danach muss größer als 0 sein.",
	"p074": "Die obere und untere Toleranz der Kurve nach dem Elektrodenkappenfräsen müssen größer als 0 sein.",
	"p075": "Das Ergebnis der Vorfilterung liegt außerhalb des Normalbereichs.",
	"p076": "Softwareversion",
	"p077": "Diese Funktion wird von der aktuellen Version nicht unterstützt.",
	"p078": "Die Primärstromkalibrierung ist auf „Systemstandard“ gesetzt und kann nicht durchgeführt werden.",
	"p079": "Stufe",
	"p080": "Untergrenze",
	"p081": "Obergrenze",
	"p082": "Die Endnummer des Schweißprogramms darf nicht kleiner als die Startnummer sein.",
	"p083": "Die Schweißprogrammnummernbereiche stimmen nicht überein. Der Vorgang kann nicht durchgeführt werden.",
	"p084": "Schweißprogramme synchronisieren",
	"p085": "Abweichungen",
	"p086": "Alle identisch",
	"p087": "Quell- und Zielgerät sind identisch. Eine Synchronisierung ist nicht möglich.",
	"p088": "] Schweißprogrammparameter auf das Zielgerät:",
	"p089": "Parametersynchronisierung",
	"p090": "Stromkoeffizient",
	"p091": "Maximaler Sekundärausgangsstrom",
	"p092": "Aktueller Leistungsfaktorwinkel",
	"p093": "Aktueller Zündsteuerwinkel",
	"p094": "Suchkriterien",
	"p095": "Schlüsselwort",
	"p096": "Erfassungszeitpunkt",
	"u001": "Benutzerverwaltung",
	"u002": "Benutzer anlegen",
	"u003": "Name",
	"u004": "Rolle",
	"u005": "Passwort",
	"u006": "Benutzer bearbeiten",
	"u007": "Betrachter",
	"u008": "Bediener",
	"u009": "Administrator",
	"u010": "Nicht aktiviert",
	"u011": "Aktiv",
	"u012": "Gesperrt",
	"u013": "Der Benutzername muss mindestens 3 Zeichen enthalten.",
	"u014": "Der Name muss mindestens 3 Zeichen enthalten.",
	"u015": "Das Passwort muss mindestens 3 Zeichen enthalten.",
	"u016": "Wählen Sie eine Rolle aus.",
	"u017": "Wählen Sie einen Status aus.",
	"u018": "Benutzer erfolgreich aktualisiert.",
	"u019": "Benutzer erfolgreich hinzugefügt.",
	"u020": "Beim Abrufen der Benutzerdaten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"u021": "Benutzer erfolgreich gelöscht.",
	"u022": "Benutzer erfolgreich wiederhergestellt.",
	"u023": "Der Benutzername ist bereits vorhanden. Geben Sie einen anderen Namen ein.",
	"u024": "Beim Hinzufügen des Benutzers ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"u025": "Beim Aktualisieren des Benutzers ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"u026": "Beim Löschen des Benutzers ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"u027": "Beim Wiederherstellen des Benutzers ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"u028": "Bediener-ID",
	"u029": "Rollenverwaltung",
	"u030": "Rolle anlegen",
	"u031": "Beim Abrufen der Rollendaten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"u032": "Der Rollenname ist bereits vorhanden. Geben Sie einen anderen Namen ein.",
	"u033": "Beim Hinzufügen der Rolle ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"u034": "Beim Aktualisieren der Rolle ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"u035": "Beim Löschen der Rolle ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"u036": "Beim Wiederherstellen der Rolle ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"u037": "Rolle erfolgreich hinzugefügt.",
	"u038": "Rolle erfolgreich aktualisiert.",
	"u039": "Rolle erfolgreich gelöscht.",
	"u040": "Rolle erfolgreich wiederhergestellt.",
	"u041": "Rollenname",
	"u042": "Rolle bearbeiten",
	"u043": "Der Rollenname ist erforderlich und muss mindestens 2 Zeichen enthalten.",
	"u044": "Berechtigungen",
	"u045": "Bereich",
	"u046": "Bereiche anzeigen",
	"u047": "Berechtigungseinstellungen",
	"u048": "Geräte",
	"u049": "Geräte anzeigen",
	"u050": "Geräte verbinden/trennen",
	"u051": "Benutzer",
	"u052": "Benutzer anzeigen",
	"u053": "Schweißprogrammbibliothek anzeigen",
	"u054": "Schweißprogrammbibliothek verwalten",
	"u055": "Systemprotokolle anzeigen",
	"u056": "Systemprotokolle verwalten",
	"u057": "Systeminitialisierung anzeigen",
	"u058": "Systeminitialisierung verwalten",
	"u059": "Echtzeitüberwachung anzeigen",
	"u060": "Echtzeitüberwachung bedienen",
	"u061": "Echtzeitüberwachung anzeigen",
	"u062": "Echtzeitüberwachung bedienen",
	"u063": "Schweißprogrammparameter anzeigen",
	"u064": "Schweißprogrammparameter bearbeiten",
	"u065": "Produktionsverwaltung anzeigen",
	"u066": "Produktionsverwaltung bedienen",
	"u067": "Systemparameter anzeigen",
	"u068": "Systemparameter bearbeiten",
	"u069": "Schweißdatensätze anzeigen",
	"u070": "Schweißdatensätze verwalten",
	"u071": "Alarmdatensätze anzeigen",
	"u072": "Alarmdatensätze verwalten",
	"u073": "Änderungsprotokolle anzeigen",
	"u074": "Änderungsprotokolle verwalten",
	"u075": "Schweißpunktverwaltung anzeigen",
	"u076": "Schweißpunktverwaltung bedienen",
	"u077": "Rollen anzeigen",
	"u078": "Berechtigungen erfolgreich festgelegt.",
	"u079": "Passwort bestätigen",
	"u080": "Die Passwörter stimmen nicht überein. Geben Sie sie erneut ein!",
	"u081": "Sie sind nicht berechtigt, die Registrierungsinformationen abzurufen. Lassen Sie sich zuerst autorisieren.",
	"u082": "Registrierungsinformationen fehlen. Aktivieren Sie zuerst das Produkt.",
	"u083": "Ungültige Registrierungsinformationen. Registrieren Sie das Produkt erneut.",
	"u084": "Dies ist eine Testversion. Fordern Sie einen Aktivierungscode an, um die Software zu verwenden.",
	"u085": "Aktivieren",
	"u086": "Produktaktivierung",
	"u087": "Produktseriennummer",
	"u088": "Senden Sie die unten angegebene Produktseriennummer oder den QR-Code links an den Hersteller, um einen Aktivierungscode zu erhalten.",
	"u089": "Aktivierungscode eingeben",
	"u090": "Wenden Sie sich bei Fragen an den technischen Support.",
	"u091": "Erfolgreich kopiert.",
	"u092": "Kopieren fehlgeschlagen.",
	"u093": "Produkt aktivieren",
	"u094": "Aktivierung anzeigen",
	"u095": "Aktivierung durchführen",
	"u096": "Fehler bei der Aktivierung des Gerätetyps.",
	"u097": "Aktivierungscode konnte nicht erzeugt werden.",
	"u098": "Der Aktivierungscode ist falsch.",
	"u099": "Geben Sie den Aktivierungscode ein.",
	"u100": "Die Produktseriennummer fehlt.",
	"u102": "Der Aktivierungscode ist ungültig!",
	"u103": "Aktivierungsinformationen konnten nicht geschrieben werden. Bitte versuchen Sie es später erneut.",
	"u104": "Aktivierung erfolgreich. Die entsprechenden Berechtigungen werden gemäß Ihrem Aktivierungscode freigeschaltet. Wenden Sie sich bei Fragen an den Hersteller.",
	"u105": "Passwort ändern",
	"u106": "Aktuelles Passwort",
	"u107": "Neues Passwort",
	"u108": "Geben Sie das aktuelle Passwort ein.",
	"u109": "Das aktuelle Passwort ist falsch.",
	"u110": "Geben Sie das neue Passwort ein.",
	"u111": "Passwort erfolgreich geändert.",
	"u112": "Passwort konnte nicht geändert werden.",
	"u113": "Angezeigte Spalten",
	"u114": "Wählen Sie die anzuzeigenden Spalten aus.",
	"u115": "Wählen Sie mindestens eine anzuzeigende Spalte aus.",
	"l001": "Konsole",
	"l002": "Verbinden",
	"l003": "Alle verbinden",
	"l004": "Alle trennen",
	"l005": "Alarm",
	"l006": "Erfolgreich getrennt.",
	"l007": "Erfolgreich verbunden.",
	"l008": "Trennen fehlgeschlagen.",
	"l009": "Verbindung fehlgeschlagen.",
	"l010": "Alle zuklappen",
	"l011": "Alle aufklappen",
	"b001": "Datenbankverwaltung",
	"b002": "Schweißprogrammbibliothek",
	"b003": "Systemparameter kopieren",
	"b004": "Parametervergleich",
	"b005": "Stromgrenzparameter",
	"b006": "Schweißprogramm-Nr.",
	"b007": "Schweißprogrammname",
	"b008": "Minimum Schweißstufe 1",
	"b009": "Maximum Schweißstufe 1",
	"b010": "Minimum Schweißstufe 2",
	"b011": "Maximum Schweißstufe 2",
	"b012": "Minimum Schweißstufe 3",
	"b013": "Maximum Schweißstufe 3",
	"b014": "Leistungsregelungsmodus",
	"b015": "Hybrid",
	"b016": "Konstantstrom",
	"b017": "Tastverhältnis",
	"b018": "Vorpressen",
	"b019": "Nachsetzen",
	"b020": "Vorschweißen",
	"b021": "Kühlen",
	"b022": "Stromanstieg",
	"b023": "Schweißstufe 1",
	"b024": "Kühlzeit 1",
	"b025": "Schweißstufe 2",
	"b026": "Kühlzeit 2",
	"b027": "Schweißstufe 3",
	"b028": "Stromabfall",
	"b029": "Kühlen",
	"b030": "Nachschweißen",
	"b031": "Nachhaltezeit",
	"b032": "Pausenzeit",
	"b033": "Kopieren",
	"b034": "Diese Gruppe löschen",
	"b035": "Diese Schweißprogrammgruppe herunterladen",
	"b036": "Schweißprogramme stapelweise herunterladen",
	"b037": "Impulsanzahl Schweißstufe 2",
	"b038": "Keine Konfigurationsdaten.",
	"b039": "Fehler beim Abrufen des maximalen Schweißprogrammwerts.",
	"b040": "Schweißprogramm",
	"b041": "Beim Hinzufügen des Schweißprogramms ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"b042": "Schweißprogramm erfolgreich hinzugefügt.",
	"b043": "Beim Aktualisieren des Schweißprogramms ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"b044": "Schweißprogramm erfolgreich aktualisiert.",
	"b045": "Beim Löschen des Schweißprogramms ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"b046": "Schweißprogramm erfolgreich gelöscht.",
	"b047": "Die Schweißprogrammnummer ist bereits vorhanden. Ändern Sie sie und senden Sie erneut.",
	"b048": "Beim Abrufen der Schweißprogrammnummer ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"b049": "Der Schweißprogrammname ist erforderlich.",
	"b050": "Beim Kopieren des Schweißprogramms ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"b051": "Schweißprogramm erfolgreich kopiert.",
	"b052": "Wählen Sie das zu löschende Schweißprogramm aus.",
	"b053": "Wählen Sie das zu löschende Schweißprogramm aus.",
	"b054": "Wählen Sie das zu kopierende Schweißprogramm aus.",
	"b055": "Gelöschte Daten können nicht wiederhergestellt werden. Daten löschen?",
	"b056": "Alle auswählen",
	"b057": "Quellgerät",
	"b058": "Zielgerät",
	"b059": "Alle Systemparameter herunterladen",
	"b060": "Vergleichen",
	"b061": "Vergleichsmethode",
	"b062": "Steuerung",
	"b063": "Fehler beim Abfragen der Daten der Schweißprogrammbibliothek.",
	"b064": "Vorgangsfehler.",
	"b065": "Parameter",
	"b066": "Mindeststrom Schweißstufe 1",
	"b067": "Maximalstrom Schweißstufe 1",
	"b068": "Mindeststrom Schweißstufe 2",
	"b069": "Maximalstrom Schweißstufe 2",
	"b070": "Mindeststrom Schweißstufe 3",
	"b071": "Maximalstrom Schweißstufe 3",
	"b072": "Vorpresszeit",
	"b073": "Luftdruck-Sollwert Vorpressen",
	"b074": "Nachsetzzeit",
	"b075": "Luftdruck-Sollwert Nachsetzen",
	"b076": "Regelungsart Vorschweißen",
	"b077": "Vorschweißstrom",
	"b078": "Vorschweißzeit",
	"b079": "[Reserviert] Vorschweißkraft [kN (0–10000) oder % (0–100)]",
	"b080": "Kühlzeit 0",
	"b081": "[Reserviert] Kühlkraft 0 (kN oder %)",
	"b082": "Stromanstiegszeit",
	"b083": "Regelungsart Schweißstufe 1",
	"b084": "Strom Schweißstufe 1",
	"b085": "Zeit Schweißstufe 1",
	"b086": "UIP-Funktionsauswahl (0–1)",
	"b087": "Kühlzeit 1",
	"b088": "[Reserviert] Kraft Schweißstufe 1 [kN (0–10000) oder % (0–100)]",
	"b089": "Regelungsart Schweißstufe 2",
	"b090": "Strom Schweißstufe 2",
	"b091": "Zeit Schweißstufe 2",
	"b092": "Kraft Schweißstufe 2",
	"b093": "Kühlzeit 2",
	"b094": "UIP-Referenzwert (%)",
	"b095": "Impulsanzahl Schweißstufe 2",
	"b096": "Regelungsart Schweißstufe 3",
	"b097": "Strom Schweißstufe 3",
	"b098": "Zeit Schweißstufe 3",
	"b099": "Oberes UIP-Toleranzband (%)",
	"b100": "Stromabfallzeit",
	"b101": "Kühlzeit 3",
	"b102": "Oberes bedingtes UIP-Toleranzband",
	"b103": "Regelungsart Nachschweißen",
	"b104": "Nachschweißstrom",
	"b105": "Nachschweißzeit",
	"b106": "Unteres bedingtes UIP-Toleranzband",
	"b107": "Nachhaltezeit",
	"b108": "Unteres UIP-Toleranzband",
	"b109": "Pausenzeit",
	"b110": "Kraft während der Pausenzeit",
	"b111": "Leistungsregelung (0–2): 0 = Konstantstrom, 1 = Tastverhältnis, 2 = Hybrid",
	"b112": "Widerstandsschwelle für Austreibungserkennung",
	"b113": "Steuerung 1",
	"b114": "Steuerung 2",
	"b115": "Schweißprogrammbibliothek 1",
	"b116": "Schweißprogrammbibliothek 2",
	"b117": "Diese Schweißprogrammgruppe herunterladen",
	"b118": "Schweißprogramme stapelweise herunterladen",
	"b119": "Gerätenummer auswählen:",
	"b120": "Auf Steuerungsposition herunterladen:",
	"b121": "Gruppe",
	"b122": "Steuerung",
	"b123": "Von",
	"b124": "Bis",
	"b125": "Erfolgreich heruntergeladen.",
	"b126": "Fehler beim Abrufen des Gerätetyps.",
	"b127": "Die Schweißprogrammnummer des Zielgeräts liegt außerhalb des Bereichs (0–{{.a}}).",
	"b128": "Schweißprogramm-Nr. „{{.a}}“ ist nicht vorhanden.",
	"b129": "Download fehlgeschlagen.",
	"b130": "Ungültige Bereichsauswahl.",
	"b131": "Die Downloadbereiche stimmen nicht überein ({{.a}}–{{.b}}).",
	"b132": "Benutzer „{{.a}}“ hat Schweißprogramm-Nr. „{{.c}}“ auf Gerät {{.b}} heruntergeladen.",
	"b133": "Benutzer „{{.a}}“ hat die Schweißprogramme {{.c}}–{{.d}} stapelweise auf die Positionen {{.e}}–{{.f}} des Geräts {{.b}} heruntergeladen.",
	"b134": "Wählen Sie ein Quellgerät und ein Zielgerät aus.",
	"b135": "Vorgang bestätigen",
	"b136": "Gerät [ synchronisieren",
	"b137": "Gerät [ synchronisieren",
	"b138": "] Systemparameter auf das Zielgerät übertragen?",
	"b139": "Die übermittelten Daten sind keine gültige Steuerungsnummer.",
	"b140": "Benutzer „{{.a}}“ hat Systemparameter von Geräte-ID „{{.b}}“ nach „{{.c}}“ kopiert.",
	"b141": "Die Schweißprogrammnummern sind identisch und können nicht verglichen werden.",
	"b142": "Die Schweißprogrammnummer liegt außerhalb des Bereichs (0–959).",
	"b143": "Die Schweißprogrammnummer liegt außerhalb des Bereichs (0–63).",
	"b144": "Steuerung nicht gefunden.",
	"b145": "[Reserviert] Kraft Schweißstufe 1 [kN (0–10000) oder % (0–100)]",
	"b146": "[Reserviert] Kühlkraft 2 [kN (0–10000) oder % (0–100)]",
	"b147": "[Reserviert] Kühlkraft 3 [kN (0–10000) oder % (0–100)]",
	"b148": "[Reserviert] Nachschweißkraft [kN (0–10000) oder % (0–100)]",
	"b149": "[Reserviert] Nachhaltekraft [kN (0–10000) oder % (0–100)]",
	"b150": "Dasselbe Schweißprogramm kann nicht mit sich selbst verglichen werden.",
	"b151": "Ungültige Eingabe für {{.a}}.",
	"b152": "Fehler bei der Eingabevalidierung.",
	"b153": "Vom Gerät in die Offline-Bibliothek synchronisieren",
	"b154": "Von der Offline-Bibliothek auf das Gerät synchronisieren",
	"b155": "Nr.",
	"b156": "Synchronisieren",
	"b157": "Ungültige Bereichsauswahl.",
	"b158": "Benutzer „{{.a}}“ hat Schweißprogramm „{{.d}}“ von Gerät „{{.c}}“ (Geräte-ID {{.b}}) in die Offline-Bibliothek synchronisiert.",
	"b159": "Synchronisierung erfolgreich abgeschlossen.",
	"b160": "Synchronisierung fehlgeschlagen.",
	"b161": "Benutzer „{{.a}}“ hat das Offline-Bibliotheks-Schweißprogramm „{{.c}}“ für Geräte-ID „{{.b}}“ gespeichert.",
	"b162": "Erfolgreich gespeichert.",
	"b163": "Speichern fehlgeschlagen.",
	"b164": "Benutzer „{{.a}}“ hat das Offline-Bibliotheks-Schweißprogramm „{{.c}}“ auf Geräte-ID {{.b}} synchronisiert.",
	"b165": "Schweißprogrammparameter exportieren",
	"b166": "Regelungsmodus Vorschweißen",
	"b167": "Regelungsmodus Schweißstufe 1",
	"b168": "Regelungsmodus Schweißstufe 2",
	"b169": "Regelungsmodus Schweißstufe 3",
	"b170": "Regelungsmodus Nachschweißen",
	"b171": "Beim Import werden die vorhandenen Daten überschrieben. Fortfahren?",
	"b172": "Diese Datei kann nicht auf das ausgewählte Gerät importiert werden.",
	"b173": "Benutzer „{{.a}}“ hat Schweißprogramm „{{.c}}“ auf Geräte-ID {{.b}} importiert.",
	"b174": "Benutzer „{{.a}}“ hat das Offline-Bibliotheks-Schweißprogramm „{{.c}}“ für Geräte-ID {{.b}} importiert.",
	"b175": "Import abgeschlossen. {{.a}} Datensätze wurden importiert.",
	"b176": "Details",
	"b177": "Wählen Sie die zu löschenden Datensätze aus.",
	"b178": "Datensätze konnten nicht gelöscht werden.",
	"b179": "Datensätze erfolgreich gelöscht.",
	"b180": "Ausgewählte Datensätze löschen?",
	"b181": "Bestätigen",
	"b182": "Abbrechen",
	"b183": "Beim Abrufen der Schweißdatensätze ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"b184": "Aktive Schweißprogramm-Nr.",
	"b185": "Aktuelle Ablaufstufe",
	"b186": "Verstrichene Zeit der aktuellen Stufe",
	"b187": "Der Datensatz ist nicht vorhanden.",
	"b188": "Suche fehlgeschlagen. Keine passende Schweißkurve gefunden.",
	"b189": "Beim Abrufen der Alarmdatensätze ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"b190": "Beim Abrufen der Änderungsprotokolle ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"b191": "Details des Schweißprogramms",
	"b192": "Klicken Sie auf „Herunterladen“, damit der Vorgang „Löschen“ wirksam wird!",
	"b193": "Kraft liegt außerhalb des gültigen Bereichs.",
	"b194": "Blechdicke liegt außerhalb des gültigen Bereichs.",
	"b195": "Zeile",
	"b196": "Bereits vorhanden",
	"b197": "Eine andere Aufgabe läuft. Die Verarbeitung ist vorübergehend nicht verfügbar.",
	"b198": "Schweißpunktverwaltung: Import erfolgreich abgeschlossen.",
	"b199": "Schweißpunktverwaltung: Import fehlgeschlagen.",
	"b200": "Schweißpunktverwaltung: Validierung erfolgreich abgeschlossen.",
	"b201": "Schweißpunktverwaltung: Validierung fehlgeschlagen.",
	"b202": "Schweißpunktverwaltung: Löschvorgang erfolgreich abgeschlossen.",
	"b203": "Schweißpunktverwaltung: Löschvorgang fehlgeschlagen.",
	"b204": "Kraft liegt außerhalb des Bereichs (0–65535).",
	"b205": "Blechdicke liegt außerhalb des Bereichs (0–655,35).",
	"b206": "Wählen Sie ein Schweißprogramm aus. Falls keines vorhanden ist, legen Sie zuerst eines an!",
	"b207": "Schweißpunktverwaltung: Import erfolgreich abgeschlossen.",
	"b208": "Schweißpunktverwaltung: Import fehlgeschlagen.",
	"b209": "Lokale Schweißpunktdaten konnten nicht gelöscht werden.",
	"b210": "Schweißpunkt konnte nicht angelegt werden.",
	"b211": "Der Parameter „start“ fehlt!",
	"b212": "Der Parameter „start“ muss eine Ganzzahl sein!",
	"b213": "Der Parameter „end“ fehlt!",
	"b214": "Der Parameter „end“ muss eine Ganzzahl sein!",
	"b215": "Impulsbreiten-Referenzwert",
	"b216": "Kumulierte Impulsbreite",
	"b217": "Impulsbreitenzähler",
	"b218": "Schweißpunktverwaltung: Download fehlgeschlagen.",
	"b219": "Der Impulsbreitenzähler kann nur auf 0 zurückgesetzt werden.",
	"b220": "Der Impulsbreitenzähler kann nur auf 0 zurückgesetzt werden. Dabei werden auch Impulsbreiten-Referenzwert und kumulierte Impulsbreite auf 0 gesetzt.",
	"b221": "Quell- und Zielgerätetyp stimmen nicht überein.",
	"b222": "Funktionszentrum",
	"b223": "Die aktuellen Programparameter wurden geändert, aber nicht auf das Gerät heruntergeladen. Vor dem Verlassen herunterladen?",
	"b224": "Direkt verlassen",
	"r001": "Gerätestatus",
	"r002": "Betrieb",
	"r003": "Elektrodenkappenfräsen",
	"r004": "Schweißen",
	"r005": "Prüfen",
	"r006": "Kraftprüfung",
	"r007": "Probeschweißung",
	"r008": "Alarm",
	"r009": "Alarmdatensätze anzeigen",
	"r010": "E/A-Status",
	"r011": "Schweißkurven",
	"r012": "Steuerungsinformationen",
	"r013": "Echtzeitdaten",
	"r014": "Schweißpunktzähler je Werkstück",
	"r015": "Schichtproduktionszähler",
	"r016": "Gesamtproduktionszähler",
	"r017": "Gesamtschweißpunktzähler",
	"r018": "Abgeschlossene Stepper-Stufen",
	"r019": "Durchgeführte Elektrodenkappenfräsungen",
	"r020": "DC-Zwischenkreisspannung",
	"r021": "Austreibungszähler des aktiven Schweißprogramms",
	"r022": "Gesamtaustreibungszähler",
	"r023": "Hardwareversion der Steuerung",
	"r024": "Softwareversion der Steuerung",
	"r025": "CPLD-Softwareversion",
	"r026": "Bootloader-Version",
	"r027": "Elektrode",
	"r028": "Eingang",
	"r029": "Ausgang",
	"r030": "Startsignal 1",
	"r031": "Startsignal 2",
	"r032": "Programmauswahl 1",
	"r033": "Programmauswahl 2",
	"r034": "Programmauswahl 4",
	"r035": "Programmauswahl 8",
	"r036": "Programmauswahl 16",
	"r037": "Programmauswahl 32",
	"r038": "Prüfen / Schweißen",
	"r039": "Alarmrücksetzung",
	"r040": "Betrieb / Elektrodenkappenfräsen",
	"r041": "Not-Halt",
	"r042": "Transformator-Temperaturschalter",
	"r043": "Umrichter-Temperaturschalter",
	"r044": "Wasserdurchflussschalter",
	"r045": "Luftdruckschalter",
	"r046": "Schweißfreigabe",
	"r047": "Reserviert",
	"r048": "Zählerrücksetzung",
	"r049": "Programmauswahl 64",
	"r050": "Programmauswahl 128",
	"r051": "Programmauswahl 256",
	"r052": "Programmauswahl 512",
	"r053": "Bestätigung Elektrodenkappenfräsen",
	"r054": "Bestätigung Elektrodenwechsel",
	"r055": "Reserviert 28",
	"r056": "Reserviert 29",
	"r057": "Reserviert 30",
	"r058": "Reserviert 31",
	"r059": "Maschine bereit",
	"r060": "Luftventil 1",
	"r061": "Luftventil 2",
	"r062": "Luftventil 3",
	"r063": "Luftventil 4",
	"r064": "Schweißung abgeschlossen",
	"r065": "IGBT-Ansteuerung",
	"r066": "Schweißanforderung",
	"r067": "Motorausgang",
	"r068": "Alarmausgang",
	"r069": "Elektrodenkappenfräsen",
	"r070": "Elektrodenwechsel",
	"r071": "Ventil für Elektrodenkappenfräsen",
	"r072": "Ablauf abgeschlossen",
	"r073": "Reserviert 20",
	"r074": "Reserviert 21",
	"r075": "Reserviert 22",
	"r076": "Reserviert 23",
	"r077": "Reserviert 24",
	"r078": "Reserviert 25",
	"r079": "Reserviert 26",
	"r080": "Reserviert 27",
	"r081": "Strom",
	"r082": "Spannung",
	"r083": "Widerstand",
	"r084": "Kraft",
	"r085": "Erfassungseinstellungen",
	"r086": "Einstellungen",
	"r087": "Stromkurve erfassen",
	"r088": "Widerstandskurve erfassen",
	"r089": "Spannungskurve erfassen",
	"r090": "Kraftkurve erfassen",
	"r091": "Einstellungen erfolgreich gespeichert.",
	"r092": "Kurvenerfassungseinstellungen konnten nicht aktualisiert werden.",
	"r093": "Kurvenerfassungseinstellungen erfolgreich aktualisiert.",
	"r094": "Unbekannter Vorgangstyp.",
	"r095": "Ungültige Geräte-ID.",
	"r096": "Das Gerät ist offline. Dieser Vorgang ist nicht zulässig.",
	"r097": "Vorgang erfolgreich abgeschlossen.",
	"r098": "Vorgang fehlgeschlagen.",
	"r099": "Unbekannter Vorgang: {{.a}}",
	"r100": "Keine Anzeigeparameterdaten gefunden.",
	"r101": "Schweißdaten",
	"r102": "Statistikdaten",
	"r103": "Zähler",
	"r104": "Anzeigen",
	"r105": "Schweißdatensatz-Nr.",
	"r106": "Softwareversion der Steuerung",
	"r107": "Schweißpunktverwaltung: Aktualisierung erfolgreich abgeschlossen.",
	"r108": "Schweißpunktverwaltung: Aktualisierung fehlgeschlagen.",
	"r109": "Importierte Daten werden mit vorhandenen Daten zusammengeführt. Fortfahren?",
	"r110": "Fehler beim Abfragen der Schweißpunktinformationen.",
	"r111": "Dieser Vorgang ist im Modus „Probeschweißung“ oder „Kraftprüfung“ nicht zulässig.",
	"r112": "Dieser Vorgang ist im Modus „Elektrodenkappenfräsen“ nicht zulässig.",
	"r113": "Funktion befindet sich in Entwicklung.",
	"r114": "Ziehen Sie einen Bereich auf, um hineinzuzoomen. Doppelklicken Sie, um die Standardskalierung wiederherzustellen.",
	"r115": "Systemdatei konnte nicht gelesen werden.",
	"r116": "Neuen Schweißpunkt bestätigen",
	"r117": "Neuen Schweißpunkt auswählen",
	"r118": "Austreibungsstellen anzeigen",
	"r119": "Trendüberwachung",
	"r120": "Parameter anzeigen",
	"r121": "Trend",
	"r122": "Strom Schweißstufe 1 (kA)",
	"r123": "Strom Schweißstufe 2 (kA)",
	"r124": "Strom Schweißstufe 3 (kA)",
	"r125": "Datensatzbegrenzung",
	"r126": "Ungültige Eingabe der Schweißprogrammparameter.",
	"r127": "Vorschweißstrom (kA)",
	"r128": "Nachschweißstrom (kA)",
	"r129": "UIP",
	"r130": "Trennen Sie mehrere Schweißprogrammnummern durch Kommas.",
	"r131": "Geben Sie eine Schweißprogrammnummer ein.",
	"r132": "Die Schweißprogrammnummer muss eine Ganzzahl sein.",
	"r133": "Die Schweißpunkt-Zuordnungsnummer muss eine Ganzzahl sein.",
	"r134": "Geben Sie eine gültige Schweißpunktanzahl ein.",
	"r135": "Die Anzahl der Echtzeit-Schweißpunkte darf 1000 nicht überschreiten.",
	"r136": "Schweißkurve",
	"r137": "Echtzeit",
	"r138": "Historie",
	"r139": "Echtzeitdaten können nur Schweißdatensätze der letzten Woche abfragen.",
	"r140": "Die Anzahl historischer Schweißpunkte darf 10000 nicht überschreiten.",
	"r141": "Widerstands-Referenzkurve",
	"r142": "Energie-Referenzwert des Schweißprogramms, Low-Word",
	"r143": "Energie-Referenzwert des Schweißprogramms, High-Word",
	"r144": "Energie-Referenzwert des Schweißprogramms",
	"r145": "UIR-Kurve bearbeiten",
	"r146": "Sicherheitslichtvorhang ausgelöst",
	"r147": "Kühlwasseralarm",
	"r148": "Schaltschranktür-Alarm",
	"r149": "Schweißsteuerungsfehler",
	"r150": "Druckluftversorgungsdruckfehler",
	"r151": "Wasserdurchflussfehler",
	"r152": "Wassertemperaturfehler",
	"r153": "Wassertemperatur-Obergrenzenalarm",
	"r154": "Wassertemperatur-Untergrenzenalarm",
	"r155": "Schweißdruck-Obergrenzenalarm",
	"r156": "Schweißdruck-Untergrenzenalarm",
	"r157": "Aufschmelzschwellen-Obergrenzenalarm",
	"r158": "Aufschmelzschwellen-Untergrenzenalarm",
	"r159": "Elektrode 1 Festelektrode Positionierstift nicht ausgefahren",
	"r160": "Elektrode 1 Festelektrode Positionierstift nicht zurückgezogen",
	"r161": "Elektrode 1 Bewegungselektrode nicht in oberer Grundstellung",
	"r162": "Elektrode 1 Bewegungselektrode nicht in unterer Endlage",
	"r163": "Elektrode 1 Bewegungselektrode nicht in kleiner Öffnungsposition",
	"r164": "Elektrode 1 Bewegungselektrode Positionierstift nicht ausgefahren",
	"r165": "Elektrode 1 Bewegungselektrode Positionierstift nicht zurückgezogen",
	"r166": "Elektrode 2 Festelektrode Positionierstift nicht ausgefahren",
	"r167": "Elektrode 2 Festelektrode Positionierstift nicht zurückgezogen",
	"r168": "Elektrode 2 Bewegungselektrode nicht in oberer Grundstellung",
	"r169": "Elektrode 2 Bewegungselektrode nicht in unterer Endlage",
	"r170": "Elektrode 2 Bewegungselektrode nicht in kleiner Öffnungsposition",
	"r171": "Elektrode 2 Bewegungselektrode Positionierstift nicht ausgefahren",
	"r172": "Elektrode 2 Bewegungselektrode Positionierstift nicht zurückgezogen",
	"r173": "Förderer 1 nicht in Grundstellung",
	"r174": "Förderer 2 nicht in Grundstellung",
	"r175": "Förderer 3 nicht in Grundstellung",
	"r176": "Förderer 4 nicht in Grundstellung",
	"r177": "Förderer 1 nicht in Endlage",
	"r178": "Förderer 2 nicht in Endlage",
	"r179": "Förderer 3 nicht in Endlage",
	"r180": "Förderer 4 nicht in Endlage",
	"r181": "Förderer 1 Sammelalarm",
	"r182": "Förderer 1 Fehler: Materialmangelalarm",
	"r183": "Förderer 1 Fehler: Hubzylinder-Endlagenalarm",
	"r184": "Förderer 1 Fehler: Hubzylinder-Grundstellungsalarm",
	"r185": "Förderer 1 Fehler: Grundstellungsalarm",
	"r186": "Förderer 1 Fehler: Endlagenalarm",
	"r187": "Förderer 2 Sammelalarm",
	"r188": "Förderer 2 Fehler: Materialmangelalarm",
	"r189": "Förderer 2 Fehler: Hubzylinder-Endlagenalarm",
	"r190": "Förderer 2 Fehler: Hubzylinder-Grundstellungsalarm",
	"r191": "Förderer 2 Fehler: Grundstellungsalarm",
	"r192": "Förderer 2 Fehler: Endlagenalarm",
	"r193": "Förderer 3 Sammelalarm",
	"r194": "Förderer 3 Fehler: Materialmangelalarm",
	"r195": "Förderer 3 Fehler: Hubzylinder-Endlagenalarm",
	"r196": "Förderer 3 Fehler: Hubzylinder-Grundstellungsalarm",
	"r197": "Förderer 3 Fehler: Grundstellungsalarm",
	"r198": "Förderer 3 Fehler: Endlagenalarm",
	"r199": "Förderer 4 Sammelalarm",
	"r200": "Förderer 4 Fehler: Materialmangelalarm",
	"r201": "Förderer 4 Fehler: Hubzylinder-Endlagenalarm",
	"r202": "Förderer 4 Fehler: Hubzylinder-Grundstellungsalarm",
	"r203": "Förderer 4 Fehler: Grundstellungsalarm",
	"r204": "Förderer 4 Fehler: Endlagenalarm",
	"r205": "Elektrode 1 Bewegungselektrode Fräsalarm",
	"r206": "Elektrode 1 Festelektrode Fräsalarm",
	"r207": "Elektrode 1 Bewegungselektrode Wechselalarm",
	"r208": "Elektrode 1 Festelektrode Wechselalarm",
	"r209": "Elektrode 2 Bewegungselektrode Fräsalarm",
	"r210": "Elektrode 2 Festelektrode Fräsalarm",
	"r211": "Elektrode 2 Bewegungselektrode Wechselalarm",
	"r212": "Elektrode 2 Festelektrode Wechselalarm",
	"r213": "Elektrode 1 Mutter/Schraube Poka Yoke: Prüfen, ob fehlend, schräg oder falscher Typ",
	"r214": "Elektrode 1 Mutter/Schraube Poka Yoke: Prüfen, ob Fremdkörper auf Mutter/Schraube",
	"r215": "Elektrode 1 Mutter/Schraube Poka Yoke: Prüfen auf falsche Mutterausrichtung oder falschen Schraubentyp",
	"r216": "Elektrode 2 Mutter/Schraube Poka Yoke: Prüfen, ob fehlend, schräg oder falscher Typ",
	"r217": "Elektrode 2 Mutter/Schraube Poka Yoke: Prüfen, ob Fremdkörper auf Mutter/Schraube",
	"r218": "Elektrode 2 Mutter/Schraube Poka Yoke: Prüfen auf falsche Mutterausrichtung oder falschen Schraubentyp",
	"r219": "Werkstückschweißpunkte voll, Zähler zurücksetzen",
	"r220": "Vorab-Zuführungsfunktion nicht aktiviert",
	"r221": "Nicht im Komponentenkonfigurationsmodus",
	"r222": "Schweißsteuerung nicht bereit",
	"r223": "System beim Fräsen nicht im Prüfmodus",
	"r224": "System bei Kalibrierung nicht im Prüfmodus",
	"r225": "Roboterarmzuführung nicht abgeschlossen",
	"r226": "System nicht im Automatikmodus",
	"r227": "System nicht im Handmodus",
	"r228": "System nicht im Online-Modus",
	"r229": "System nicht im Einzelmodus",
	"r230": "System nicht im Fräsmodus",
	"r231": "Fernsteuerung nicht aktiviert",
	"r232": "Roboter nicht bereit",
	"r233": "Elektrode 1 Nullpunkt nicht kalibriert",
	"r234": "Elektrode 2 Nullpunkt nicht kalibriert",
	"r235": "Elektrode 1 nicht im Fernfräsmodus",
	"r236": "Elektrode 1 nicht im Fernarbeitsmodus",
	"r237": "Elektrode 2 nicht im Fernfräsmodus",
	"r238": "Elektrode 2 nicht im Fernarbeitsmodus",
	"r239": "Automatik-Zeitüberschreitung: Positionierstiftbewegung vor Fördererzuführung",
	"r240": "Automatik-Zeitüberschreitung: Vorab-Zuführung",
	"r241": "Automatik-Zeitüberschreitung: Fördererzuführung",
	"r242": "Automatik-Zeitüberschreitung: Positionierstiftbewegung vor Vorpressen",
	"r243": "Automatik-Zeitüberschreitung: Vorpressen",
	"r244": "Automatik-Zeitüberschreitung: Mutter/Schraubenprüfung",
	"r245": "Automatik-Zeitüberschreitung: Druckaufbau",
	"r246": "Automatik-Zeitüberschreitung: Druckprüfung",
	"r247": "Automatik-Zeitüberschreitung: Schweißvorbereitung",
	"r248": "Automatik-Zeitüberschreitung: Entladungsfreigabe",
	"r249": "Automatik-Zeitüberschreitung: Schweißen",
	"r250": "Automatik-Zeitüberschreitung: Nachhaltezeit",
	"r251": "Automatik-Zeitüberschreitung: Rückhub",
	"r252": "Automatik-Zeitüberschreitung: Schweißabschlussimpuls",
	"r253": "Mutterprüfungs-Zeitüberschreitung",
	"r254": "Druckaufbau-Prüfungs-Zeitüberschreitung",
	"r255": "Systemrücksetz-Rückhub-Zeitüberschreitung",
	"r256": "Prozessrücksetz-Rückhub-Zeitüberschreitung",
	"r257": "Wegaufzeichnungs-Zeitüberschreitung: Rückhub",
	"r258": "Positionaufzeichnungs-Zeitüberschreitung: Phase Positionierstift vor Fördererzuführung",
	"r259": "Positionaufzeichnungs-Zeitüberschreitung: Phase Fördererzuführung",
	"r260": "Positionaufzeichnungs-Zeitüberschreitung: Phase Positionierstift vor Elektrodenabsenkung",
	"r261": "Positionaufzeichnungs-Zeitüberschreitung: Phase Nullpunktkalibrierung",
	"r262": "Positionaufzeichnungs-Zeitüberschreitung: Phase Elektrodenabsenkung",
	"r263": "Positionaufzeichnungs-Zeitüberschreitung: Phase Filterung",
	"r264": "Positionaufzeichnungs-Zeitüberschreitung: Phase Rückhub",
	"r265": "Werkstück-Schweißpunktintervall-Zeitüberschreitung (gezielte Löschung)",
	"r266": "Einzelteil-Schweiß-Zeitüberschreitung (gezielte Löschung)",
	"r267": "Rezeptkonfigurationsfehler: Im Online-Modus muss eine Muttermaschine konfiguriert sein",
	"r268": "Rezeptkonfigurationsfehler: Dieses Gerät hat keinen Förderer 1",
	"r269": "Rezeptkonfigurationsfehler: Dieses Gerät hat keinen Förderer 2",
	"r270": "Rezeptkonfigurationsfehler: Dieses Gerät hat keinen Förderer 3",
	"r271": "Rezeptkonfigurationsfehler: Dieses Gerät hat keinen Förderer 4",
	"r272": "Rezeptkonfigurationsfehler: Muttermaschine 1 unterstützt den ausgewählten Arbeitsmodus nicht",
	"r273": "Rezeptkonfigurationsfehler: Muttermaschine 2 unterstützt den ausgewählten Arbeitsmodus nicht",
	"r274": "Rezeptkonfigurationsfehler: Elektrode 1 hat keinen Wegmesssensor, Mutterprüfung nicht unterstützt",
	"r275": "Rezeptkonfigurationsfehler: Elektrode 2 hat keinen Wegmesssensor, Mutterprüfung nicht unterstützt",
	"r276": "Rezeptkonfigurationsfehler: Elektrode 1 hat keinen Drucksensor und keine Wägezelle, Schweißdruckprüfung nicht möglich",
	"r277": "Rezeptkonfigurationsfehler: Elektrode 2 hat keinen Drucksensor und keine Wägezelle, Schweißdruckprüfung nicht möglich",
	"r278": "Rezeptkonfigurationsfehler: Elektrode 1 hat keinen oberen Positionierstift",
	"r279": "Rezeptkonfigurationsfehler: Elektrode 2 hat keinen oberen Positionierstift",
	"r280": "Rezeptkonfigurationsfehler: Elektrode 1 hat kein Verstärkerventil",
	"r281": "Rezeptkonfigurationsfehler: Elektrode 2 hat kein Verstärkerventil",
	"r282": "Rezeptkonfigurationsfehler: Elektrode 1 unterstützt keine Elektrodenhubsteuerung",
	"r283": "Rezeptkonfigurationsfehler: Elektrode 2 unterstützt keine Elektrodenhubsteuerung",
	"r284": "Rezeptkonfigurationsfehler: Kein Förderer konfiguriert, Vorab-Zuführung nicht unterstützt",
	"r285": "Aktueller Rezept-Vorpressdruckwert fehlerhaft",
	"r286": "Aktueller Rezept-Druckaufbauwert fehlerhaft",
	"r287": "Aktueller Rezept-Rückhubdruckwert fehlerhaft",
	"r288": "Aktuelle Rezept-Rückhubdruckeinstellung fehlerhaft, verwende Systemstandard-Rückhubdruck",
	"r289": "Bewegungselektrode-Rückhubdruckeinstellung fehlerhaft",
	"r290": "Mutter-/Schraubenprüfung: Vorpressdruck im Rezept darf nicht 0 sein",
	"r291": "Systemparameter: Manueller Vorpressdruck darf nicht null sein",
	"r292": "Systemparameter: Manueller Druckaufbaudruck darf nicht null sein",
	"r293": "Systemparameter: Fräsdruckwert fehlerhaft",
	"r294": "Systemparameter: Vorpressdruckwert fehlerhaft",
	"r295": "Systemparameter: Druckaufbauwert fehlerhaft",
	"r296": "Systemparameter: Druckeinheit fehlerhaft",
	"r297": "Dieses Gerät hat keinen Förderer 1",
	"r298": "Dieses Gerät hat keinen Förderer 2",
	"r299": "Dieses Gerät hat keinen Förderer 3",
	"r300": "Dieses Gerät hat keinen Förderer 4",
	"r301": "Elektrode 1 hat keinen oberen Positionierstift",
	"r302": "Elektrode 1 hat keinen Bewegungselektroden-Positionssensor",
	"r303": "Elektrode 1 hat keinen Festelektroden-Positionssensor",
	"r304": "Elektrode 1 hat kein Verstärkerventil",
	"r305": "Elektrode 1 hat kein Wegeventil",
	"r306": "Elektrode 2 hat keinen oberen Positionierstift",
	"r307": "Elektrode 2 hat keinen Bewegungselektroden-Positionssensor",
	"r308": "Elektrode 2 hat keinen Festelektroden-Positionssensor",
	"r309": "Elektrode 2 hat kein Verstärkerventil",
	"r310": "Elektrode 2 hat kein Wegeventil",
	"r311": "Elektrode 1 Druckerfassungsfehler",
	"r312": "Elektrode 1 Fräsfehler",
	"r313": "Elektrode 1 Mutter/Schraube Positionaufzeichnungsfehler",
	"r314": "Elektrode 1 Festelektrode Anfangspositionaufzeichnungsfehler",
	"r315": "Elektrode 1 Festelektrode Fräsversatzaufzeichnungsfehler",
	"r316": "Elektrode 1 Nullpunktkalibrierungsfehler",
	"r317": "Elektrode 1 Bewegungselektroden-Bewegungsfehler",
	"r318": "Elektrode 1 Mutter/Schraube Poka Yoke: Obere Elektrodenweg-Rücksetzungsfehler",
	"r319": "Elektrode 1 Mutter/Schraube Poka Yoke: Untere Positionierstiftweg-Rücksetzungsfehler",
	"r320": "Elektrode 1 Manueller Druckaufbaufehler",
	"r321": "Elektrode 1 Manueller Vorpressfehler",
	"r322": "Elektrode 1 Positionierstift-Informationsaktualisierungsfehler",
	"r323": "Elektrode 1 Mutter/Schraube Position_Positionierstiftschwellenaktualisierungsfehler",
	"r324": "Elektrode 2 Druckerfassungsfehler",
	"r325": "Elektrode 2 Fräsfehler",
	"r326": "Elektrode 2 Mutter/Schraube Positionaufzeichnungsfehler",
	"r327": "Elektrode 2 Festelektrode Anfangspositionaufzeichnungsfehler",
	"r328": "Elektrode 2 Festelektrode Fräsversatzaufzeichnungsfehler",
	"r329": "Elektrode 2 Nullpunktkalibrierungsfehler",
	"r330": "Elektrode 2 Bewegungselektroden-Bewegungsfehler",
	"r331": "Elektrode 2 Mutter/Schraube Poka Yoke: Obere Elektrodenweg-Rücksetzungsfehler",
	"r332": "Elektrode 2 Mutter/Schraube Poka Yoke: Untere Positionierstiftweg-Rücksetzungsfehler",
	"r333": "Elektrode 2 Manueller Druckaufbaufehler",
	"r334": "Elektrode 2 Manueller Vorpressfehler",
	"r335": "Elektrode 2 Positionierstift-Informationsaktualisierungsfehler",
	"r336": "Schweißsteuerung Schweißstartfehler",
	"r337": "Rezept speichern fehlgeschlagen, prüfen Sie die Rezeptwerte",
	"r338": "Rezept lesen fehlgeschlagen",
	"r339": "Systemparameter speichern fehlgeschlagen, prüfen Sie die Werte",
	"r340": "Zeiteinstellungsfehler",
	"r341": "Zeitkalibrierungsfehler",
	"r342": "Gelesene Rezeptnummer stimmt nicht mit Ziel-Rezeptnummer überein",
	"r343": "Fördererkonfigurationsfehler",
	"r344": "Unbekannter Befehl",
	"r345": "Rezeptnummerfehler",
	"r346": "Komponentenkonfigurationsfehler",
	"r347": "Unbekannter Startmodus",
	"r348": "Kalibrierparameter speichern fehlgeschlagen",
	"r349": "Schweißmaschine Neuer Schweißpunkt-Rücksetzungsfehler",
	"r350": "Kalibrierpunkte unzureichend, mindestens zwei Kalibrierpunkte erforderlich",
	"r351": "Systemparameterimport fehlgeschlagen",
	"r352": "Gerätehardwarekonfigurationstabelle import fehlgeschlagen",
	"r353": "Zählstatistikdaten import fehlgeschlagen",
	"r354": "Rezept import fehlgeschlagen",
	"r355": "Kalibrierparameter import fehlgeschlagen",
	"r356": "Modbus RTU Master 0 Init-Fehler",
	"r357": "Modbus RTU Master 0 Enable-Fehler",
	"r358": "Modbus RTU Master 0 Taskmanager-Bindungsfehler",
	"r359": "Modbus RTU Master 1 XoneInit-Fehler",
	"r360": "Modbus RTU Master 1 Xone Enable-Fehler",
	"r361": "Modbus RTU Master 1 Xone Taskmanager-Bindungsfehler",
	"r362": "Modbus TCP Init-Fehler",
	"r363": "Modbus TCP Enable-Fehler",
	"r364": "TIM7 Startfehler",
	"r365": "Log-Initialisierungsfehler",
	"r366": "Log-Laufzeitfehler",
	"r367": "Echtzeituhr-Startfehler",
	"r368": "Echtzeituhr-Zeitfehler",
	"r369": "Digitaler E/A-Initialisierungsfehler",
	"r370": "Zustandsmaschinen-Initialisierungsfehler",
	"r371": "Modbus Master-Taskmanager 0_Fehler",
	"r372": "Modbus Master-Taskmanager 1_Xone_Fehler",
	"r373": "Schweißmaschinensteuerblock-Konfigurationsfehler",
	"r374": "Mutter/Schraube Poka Yoke: Bewegungselektrodenweg-Konfigurationsfehler",
	"r375": "Mutter/Schraube Poka Yoke: Festelektrodenpositionierstiftweg-Konfigurationsfehler",
	"r376": "Schweißmaschinensteuerbefehl ausführen fehlgeschlagen",
	"r377": "DIO-Modul Datenübertragungsfehler",
	"r378": "DIO-Modul SPI-Fehler",
	"r379": "ADC-Modul Datenübertragungsfehler",
	"r380": "ADC-Modul SPI-Fehler",
	"r381": "Anybus-Modul Seriellanschlussfehler",
	"r382": "ModbusRTU-Modul Seriellanschlussfehler",
	"r383": "Systemstromausfall erkannt",
	"r384": "Zählstatistikdaten-Speicherfehler",
	"r385": "Zählstatistikdaten-Prüffehler",
	"r386": "Zweihandstart-Funktionsmodul-Fehler",
	"r387": "Countdown-Timer-Stoppfehler",
	"r388": "Countdown-Timer-Startfehler",
	"r389": "Ereignis-Abbestellungsfehler",
	"r390": "Ereignis-Abonnementfehler",
	"r391": "Zustandsübergangsaufzeichnungsfehler",
	"r392": "IO-Stromversorgungssteuerungsfehler",
	"r393": "Zustandsbeendigungsfehler",
	"r394": "Zustandseintrittsfehler",
	"r395": "Alarmzustandseintrittsfehler",
	"r396": "Alarmzustandsbeendigungsfehler",
	"r397": "Positionierstift-Positionssteuerungsinformationsaktualisierungsfehler",
	"r398": "Zustandsanzeigefehler",
	"r399": "Digitaler Eingang Flag-Rücksetzungsfehler",
	"r400": "Digitaler Eingang Ereignisabonnementfehler",
	"r401": "Förderer 1 Steuerungsfehler",
	"r402": "Förderer 2 Steuerungsfehler",
	"r403": "Förderer 3 Steuerungsfehler",
	"r404": "Förderer 4 Steuerungsfehler",
	"s001": "Systemprotokolle",
	"s002": "Nr.",
	"s003": "Bediener",
	"s004": "Objekt-ID",
	"s005": "Zusammenfassung",
	"s006": "Vorgangszeit",
	"s007": "Status der Kalibrierstufe",
	"s008": "Stufenauswahl",
	"s009": "Bereitschaft der Steuerung freigeben und Normalbetrieb starten",
	"s010": "Schweißen der Steuerung freigeben",
	"s011": "E/A-Status des Leitrechners",
	"s012": "Fehlerlöschbefehl",
	"s013": "Sollwert des Strom-PWM-Ausgangs",
	"s014": "Sollwert des Elektrodenkraftausgangs",
	"s015": "Anzeigewert der DC-Zwischenkreisspannung",
	"s016": "Anzeigewert des Primärstroms",
	"s017": "Anzeigewert des Sekundärstroms",
	"s018": "Anzeigewert der Elektrodenkraft",
	"s019": "Rücksetzbefehl des Schweißpunktzählers",
	"s020": "PROFIBUS-Eingangsstatuswort 00",
	"s021": "PROFIBUS-Eingangsstatuswort 01",
	"s022": "PROFIBUS-Ausgangsstatuswort 00",
	"s023": "PROFIBUS-Ausgangsstatuswort 01",
	"s024": "DeviceNet-Eingangsstatuswort 00",
	"s025": "DeviceNet-Eingangsstatuswort 01",
	"s026": "DeviceNet-Ausgangsstatuswort 00",
	"s027": "DeviceNet-Ausgangsstatuswort 00",
	"s028": "Klicken Sie hier oder ziehen Sie eine Datei hierher, um sie hochzuladen.",
	"s029": "Import abgeschlossen",
	"s030": "Aktualisieren",
	"s031": "Validieren",
	"s032": "Löschen",
	"s033": "Schweißpunkt anlegen",
	"s034": "Schweißpunkt bearbeiten",
	"s035": "Reserviert",
	"s036": "Adresszeiger der historischen Alarmtabelle",
	"s037": "Alarmstatuswort (0–31)",
	"s038": "Vorschweißkraft",
	"s039": "Kühlkraft 0",
	"s040": "Kraft während des Stromanstiegs",
	"s041": "Kraft Schweißstufe 1",
	"s042": "Kühlkraft 1",
	"s043": "Kühlkraft 2",
	"s044": "Kraft Schweißstufe 3",
	"s045": "Kraft während des Stromabfalls",
	"s046": "Kühlkraft 3",
	"s047": "Nachschweißkraft",
	"s048": "Nachhaltekraft",
	"s049": "Aktuell mit Schweißzange 1 produziertes Fahrzeugmodell, Feld 00 (als ASCII-Code gespeichert)",
	"s050": "Aktuell mit Schweißzange 1 produziertes Fahrzeugmodell, Feld 01 (als ASCII-Code gespeichert)",
	"s051": "Aktuell mit Schweißzange 1 produziertes Fahrzeugmodell, Feld 02 (als ASCII-Code gespeichert)",
	"s052": "Aktuell mit Schweißzange 1 produziertes Fahrzeugmodell, Feld 03 (als ASCII-Code gespeichert)",
	"s053": "Aktuell mit Schweißzange 2 produziertes Fahrzeugmodell, Feld 00 (als ASCII-Code gespeichert)",
	"s054": "Aktuell mit Schweißzange 2 produziertes Fahrzeugmodell, Feld 01 (als ASCII-Code gespeichert)",
	"s055": "Aktuell mit Schweißzange 2 produziertes Fahrzeugmodell, Feld 02 (als ASCII-Code gespeichert)",
	"s056": "Aktuell mit Schweißzange 2 produziertes Fahrzeugmodell, Feld 03 (als ASCII-Code gespeichert)",
	"s057": "Elektrodenkraftmodus",
	"s058": "Funktionsauswahl Start 2",
	"s059": "Funktionsauswahl Schweißpunktbestätigung",
	"s060": "Nachschweißanzahl",
	"s061": "Sollwert der Kraftprüfung",
	"s062": "CPLD-Softwareversion der Steuerung",
	"s063": "Auswahl der Kommunikationsschnittstelle",
	"s064": "Kommunikationsadresse",
	"s065": "Netzwerkfunktion",
	"s066": "IP0",
	"s067": "IP1",
	"s068": "Geräteseriennummer",
	"s069": "DeviceNet-Baudrate",
	"s070": "Nennspannung",
	"s071": "Anzahl der Umrichter",
	"s072": "Funktionsauswahl Schweißfreigabe",
	"s073": "Transformator-Übersetzungsverhältnis",
	"s074": "Transformatorwirkungsgrad",
	"s075": "Konstantstrom-Regelungsmodus",
	"s076": "Primärstromschwelle",
	"s077": "Rücksetzsteuerung des IGBT-Schutzalarms",
	"s078": "Funktionsauswahl HMI-Not-Halt",
	"s079": "Funktionsauswahl Programmgruppenpriorität",
	"s080": "Funktionsauswahl Proportionaldruckregler",
	"s081": "Autarker Betrieb der Steuerung ohne HMI",
	"s082": "Auslösemodus für Betrieb mit großer Öffnung",
	"s083": "Bestätigungsfunktion Elektrodenkappenfräsen",
	"s084": "Verzögerter Start der kleinen Schweißzangenöffnung beim Hängezangenschweißen",
	"s085": "Verhältnis des Rogowski-Spulen-Strommesswerts von Schweißzange 1 zum Iststrom",
	"s086": "Verhältnis des Rogowski-Spulen-Strommesswerts von Schweißzange 2 zum Iststrom",
	"s087": "Verhältnis des CT-Strommesswerts von Schweißzange 1 zum Iststrom",
	"s088": "Verhältnis des CT-Strommesswerts von Schweißzange 2 zum Iststrom",
	"s089": "Vom System unterstützter maximaler Iststrom für Schweißzange 1",
	"s090": "Vom System unterstützter maximaler Iststrom für Schweißzange 2",
	"s091": "Aktueller Leistungsfaktorwinkel für Schweißzange 1",
	"s092": "Aktueller Leistungsfaktorwinkel für Schweißzange 2",
	"s093": "Aktueller Zündsteuerwinkel der Schweißung",
	"s094": "Öffnungszustand des Elektrodenarms nach Abschalten einer Hängezangen-Schweißsteuerung",
	"s095": "Ausgangsmodus der Signale „Schweißung abgeschlossen“ und „Ablauf abgeschlossen“",
	"s096": "Anzeigekoeffizient der DC-Zwischenkreisspannung (dieser Parameter wird nicht mehr verwendet)",
	"s097": "PWM-Ausgangssollwert Minimaler Primärstrom für Schweißzange 1",
	"s098": "PWM-Ausgangssollwert Stufe 1 Primärstrom für Schweißzange 1",
	"s099": "PWM-Ausgangssollwert Stufe 2 Primärstrom für Schweißzange 1",
	"s100": "PWM-Ausgangssollwert Stufe 3 Primärstrom für Schweißzange 1",
	"s101": "PWM-Ausgangssollwert Stufe 4 Primärstrom für Schweißzange 1",
	"s102": "PWM-Ausgangssollwert Stufe 5 Primärstrom für Schweißzange 1",
	"s103": "PWM-Ausgangssollwert Stufe 6 Primärstrom für Schweißzange 1",
	"s104": "PWM-Ausgangssollwert Maximaler Primärstrom für Schweißzange 1",
	"s105": "Messwert Minimaler Primärstrom für Schweißzange 1",
	"s106": "Messwert Stufe 1 Primärstrom für Schweißzange 1",
	"s107": "Messwert Stufe 2 Primärstrom für Schweißzange 1",
	"s108": "Messwert Stufe 3 Primärstrom für Schweißzange 1",
	"s109": "Messwert Stufe 4 Primärstrom für Schweißzange 1",
	"s110": "Messwert Stufe 5 Primärstrom für Schweißzange 1",
	"s111": "Messwert Stufe 6 Primärstrom für Schweißzange 1",
	"s112": "Messwert Maximaler Primärstrom für Schweißzange 1",
	"s113": "Anzeigewert Minimaler Primärstrom für Schweißzange 1",
	"s114": "Anzeigewert Stufe 1 Primärstrom für Schweißzange 1",
	"s115": "Anzeigewert Stufe 2 Primärstrom für Schweißzange 1",
	"s116": "Anzeigewert Stufe 3 Primärstrom für Schweißzange 1",
	"s117": "Anzeigewert Stufe 4 Primärstrom für Schweißzange 1",
	"s118": "Anzeigewert Stufe 5 Primärstrom für Schweißzange 1",
	"s119": "Anzeigewert Stufe 6 Primärstrom für Schweißzange 1",
	"s120": "Anzeigewert Maximaler Primärstrom für Schweißzange 1",
	"s121": "PWM-Ausgangssollwert Minimaler Sekundärstrom für Schweißzange 1",
	"s122": "PWM-Ausgangssollwert Stufe 1 Sekundärstrom für Schweißzange 1",
	"s123": "PWM-Ausgangssollwert Stufe 2 Sekundärstrom für Schweißzange 1",
	"s124": "PWM-Ausgangssollwert Stufe 3 Sekundärstrom für Schweißzange 1",
	"s125": "PWM-Ausgangssollwert Stufe 4 Sekundärstrom für Schweißzange 1",
	"s126": "PWM-Ausgangssollwert Stufe 5 Sekundärstrom für Schweißzange 1",
	"s127": "PWM-Ausgangssollwert Stufe 6 Sekundärstrom für Schweißzange 1",
	"s128": "PWM-Ausgangssollwert Maximaler Sekundärstrom für Schweißzange 1",
	"s129": "Messwert Minimaler Sekundärstrom für Schweißzange 1",
	"s130": "Messwert Stufe 1 Sekundärstrom für Schweißzange 1",
	"s131": "Messwert Stufe 2 Sekundärstrom für Schweißzange 1",
	"s132": "Messwert Stufe 3 Sekundärstrom für Schweißzange 1",
	"s133": "Messwert Stufe 4 Sekundärstrom für Schweißzange 1",
	"s134": "Messwert Stufe 5 Sekundärstrom für Schweißzange 1",
	"s135": "Messwert Stufe 6 Sekundärstrom für Schweißzange 1",
	"s136": "Messwert Maximaler Sekundärstrom für Schweißzange 1",
	"s137": "Anzeigewert Minimaler Sekundärstrom für Schweißzange 1",
	"s138": "Anzeigewert Stufe 1 Sekundärstrom für Schweißzange 1",
	"s139": "Anzeigewert Stufe 2 Sekundärstrom für Schweißzange 1",
	"s140": "Anzeigewert Stufe 3 Sekundärstrom für Schweißzange 1",
	"s141": "Anzeigewert Stufe 4 Sekundärstrom für Schweißzange 1",
	"s142": "Anzeigewert Stufe 5 Sekundärstrom für Schweißzange 1",
	"s143": "Anzeigewert Stufe 6 Sekundärstrom für Schweißzange 1",
	"s144": "Anzeigewert Maximaler Sekundärstrom für Schweißzange 1",
	"s145": "PWM-Ausgangssollwert Minimaler Sekundärstrom für Schweißzange 2",
	"s146": "PWM-Ausgangssollwert Stufe 1 Sekundärstrom für Schweißzange 2",
	"s147": "PWM-Ausgangssollwert Stufe 2 Sekundärstrom für Schweißzange 2",
	"s148": "PWM-Ausgangssollwert Stufe 3 Sekundärstrom für Schweißzange 2",
	"s149": "PWM-Ausgangssollwert Stufe 4 Sekundärstrom für Schweißzange 2",
	"s150": "PWM-Ausgangssollwert Stufe 5 Sekundärstrom für Schweißzange 2",
	"s151": "PWM-Ausgangssollwert Stufe 6 Sekundärstrom für Schweißzange 2",
	"s152": "PWM-Ausgangssollwert Maximaler Sekundärstrom für Schweißzange 2",
	"s153": "Messwert Minimaler Sekundärstrom für Schweißzange 2",
	"s154": "Messwert Stufe 1 Sekundärstrom für Schweißzange 2",
	"s155": "Messwert Stufe 2 Sekundärstrom für Schweißzange 2",
	"s156": "Messwert Stufe 3 Sekundärstrom für Schweißzange 2",
	"s157": "Messwert Stufe 4 Sekundärstrom für Schweißzange 2",
	"s158": "Messwert Stufe 5 Sekundärstrom für Schweißzange 2",
	"s159": "Messwert Stufe 6 Sekundärstrom für Schweißzange 2",
	"s160": "Messwert Maximaler Sekundärstrom für Schweißzange 2",
	"s161": "Anzeigewert Minimaler Sekundärstrom für Schweißzange 2",
	"s162": "Anzeigewert Stufe 1 Sekundärstrom für Schweißzange 2",
	"s163": "Anzeigewert Stufe 2 Sekundärstrom für Schweißzange 2",
	"s164": "Anzeigewert Stufe 3 Sekundärstrom für Schweißzange 2",
	"s165": "Anzeigewert Stufe 4 Sekundärstrom für Schweißzange 2",
	"s166": "Anzeigewert Stufe 5 Sekundärstrom für Schweißzange 2",
	"s167": "Anzeigewert Stufe 6 Sekundärstrom für Schweißzange 2",
	"s168": "Anzeigewert Maximaler Sekundärstrom für Schweißzange 2",
	"s169": "Ausgangssollwert Elektrodenkraftstufe 1 für Schweißzange 1",
	"s170": "Ausgangssollwert Elektrodenkraftstufe 2 für Schweißzange 1",
	"s171": "Angezeigter Messwert Elektrodenkraftstufe 1 für Schweißzange 1",
	"s172": "Angezeigter Messwert Elektrodenkraftstufe 2 für Schweißzange 1",
	"s173": "Ausgangssollwert Elektrodenkraftstufe 1 für Schweißzange 2",
	"s174": "Ausgangssollwert Elektrodenkraftstufe 2 für Schweißzange 2",
	"s175": "Angezeigter Messwert Elektrodenkraftstufe 1 für Schweißzange 2",
	"s176": "Angezeigter Messwert Elektrodenkraftstufe 2 für Schweißzange 2",
	"s177": "Primärstrom-Kalibrierparameter",
	"s178": "Sekundärstrom-Kalibrierparameter",
	"s179": "Auswahlmodus des Schweißprogramms",
	"s180": "Feinabgleichparameter Primär-Konstantstrom für Schweißzange 1",
	"s181": "Feinabgleichparameter Sekundär-Konstantstrom für Schweißzange 1",
	"s182": "Feinabgleichparameter Primär-Konstantstrom für Schweißzange 2",
	"s183": "Feinabgleichparameter Sekundär-Konstantstrom für Schweißzange 2",
	"s184": "Aufwärtsdruck beim Elektrodenkappenfräsen für Schweißzange B",
	"s185": "Fräsdruck für Schweißzange B",
	"s186": "Prozess-Schweißpunktsteuerung für Schweißzange 1",
	"s187": "Prozess-Schweißpunktsteuerung für Schweißzange 2",
	"s188": "Alarm, wenn der Schweißpunktzähler je Werkstück die vorgegebene Prozess-Schweißpunktanzahl erreicht",
	"s189": "Alarmfunktion für Schichtproduktions-Schweißpunktzähler",
	"s190": "Zeitmessung unmittelbar nach Alarmrücksetzung starten",
	"s191": "Erkennungszeit für das Ende des aktuellen Schweißzyklus von Schweißzange 1",
	"s192": "Erkennungszeit für das Ende des aktuellen Schweißzyklus von Schweißzange 2",
	"s193": "Unterer Sollwert der Schweißpunktanzahl je Werkstück für Schweißzange 1",
	"s194": "Unterer Sollwert der Schweißpunktanzahl je Werkstück für Schweißzange 2",
	"s195": "Oberer Sollwert der Schweißpunktanzahl je Werkstück für Schweißzange 1",
	"s196": "Oberer Sollwert der Schweißpunktanzahl je Werkstück für Schweißzange 2",
	"s197": "Schichtproduktions-Sollwert für Schweißzange 1",
	"s198": "Schichtproduktions-Sollwert für Schweißzange 2",
	"s199": "Schweißpunktzähler je Werkstück für Schweißzange 1",
	"s200": "Schweißpunktzähler je Werkstück für Schweißzange 2",
	"s201": "Netzausfallsicher gespeicherter Alarm-Informationswert des Zählers",
	"s202": "Konfigurationsmodus der Schweißzangenanzahl",
	"s203": "Sollwert der Stepper-Stufenanzahl für Schweißzange 1",
	"s204": "Sollwert der Stepper-Stufenanzahl für Schweißzange 2",
	"s205": "Sollwert der Fräsanzahl für Schweißzange 1",
	"s206": "Sollwert der Fräsanzahl für Schweißzange 2",
	"s207": "Schweißpunkt-Sollwert für Fräsvorwarnung der Schweißzange 1",
	"s208": "Schweißpunkt-Sollwert für Fräsvorwarnung der Schweißzange 2",
	"s209": "Stepper-Schweißpunktanzahl 1 für Schweißzange 1",
	"s210": "Leistungskompensation 1 für Schweißzange 1",
	"s211": "Kraftkompensation 1 für Schweißzange 1",
	"s212": "Stepper-Schweißpunktanzahl 2 für Schweißzange 1",
	"s213": "Leistungskompensation 2 für Schweißzange 1",
	"s214": "Kraftkompensation 2 für Schweißzange 1",
	"s215": "Stepper-Schweißpunktanzahl 3 für Schweißzange 1",
	"s216": "Leistungskompensation 3 für Schweißzange 1",
	"s217": "Kraftkompensation 3 für Schweißzange 1",
	"s218": "Stepper-Schweißpunktanzahl 4 für Schweißzange 1",
	"s219": "Leistungskompensation 4 für Schweißzange 1",
	"s220": "Kraftkompensation 4 für Schweißzange 1",
	"s221": "Stepper-Schweißpunktanzahl 5 für Schweißzange 1",
	"s222": "Leistungskompensation 5 für Schweißzange 1",
	"s223": "Kraftkompensation 5 für Schweißzange 1",
	"s224": "Stepper-Schweißpunktanzahl 6 für Schweißzange 1",
	"s225": "Leistungskompensation 6 für Schweißzange 1",
	"s226": "Kraftkompensation 6 für Schweißzange 1",
	"s227": "Stepper-Schweißpunktanzahl 7 für Schweißzange 1",
	"s228": "Leistungskompensation 7 für Schweißzange 1",
	"s229": "Kraftkompensation 7 für Schweißzange 1",
	"s230": "Stepper-Schweißpunktanzahl 8 für Schweißzange 1",
	"s231": "Leistungskompensation 8 für Schweißzange 1",
	"s232": "Kraftkompensation 8 für Schweißzange 1",
	"s233": "Stepper-Schweißpunktanzahl 9 für Schweißzange 1",
	"s234": "Leistungskompensation 9 für Schweißzange 1",
	"s235": "Kraftkompensation 9 für Schweißzange 1",
	"s236": "Stepper-Schweißpunktanzahl 1 für Schweißzange 2",
	"s237": "Leistungskompensation 1 für Schweißzange 2",
	"s238": "Kraftkompensation 1 für Schweißzange 2",
	"s239": "Stepper-Schweißpunktanzahl 2 für Schweißzange 2",
	"s240": "Leistungskompensation 2 für Schweißzange 2",
	"s241": "Kraftkompensation 2 für Schweißzange 2",
	"s242": "Stepper-Schweißpunktanzahl 3 für Schweißzange 2",
	"s243": "Leistungskompensation 3 für Schweißzange 2",
	"s244": "Kraftkompensation 3 für Schweißzange 2",
	"s245": "Stepper-Schweißpunktanzahl 4 für Schweißzange 2",
	"s246": "Leistungskompensation 4 für Schweißzange 2",
	"s247": "Kraftkompensation 4 für Schweißzange 2",
	"s248": "Stepper-Schweißpunktanzahl 5 für Schweißzange 2",
	"s249": "Leistungskompensation 5 für Schweißzange 2",
	"s250": "Kraftkompensation 5 für Schweißzange 2",
	"s251": "Stepper-Schweißpunktanzahl 6 für Schweißzange 2",
	"s252": "Leistungskompensation 6 für Schweißzange 2",
	"s253": "Kraftkompensation 6 für Schweißzange 2",
	"s254": "Stepper-Schweißpunktanzahl 7 für Schweißzange 2",
	"s255": "Leistungskompensation 7 für Schweißzange 2",
	"s256": "Kraftkompensation 7 für Schweißzange 2",
	"s257": "Stepper-Schweißpunktanzahl 8 für Schweißzange 2",
	"s258": "Leistungskompensation 8 für Schweißzange 2",
	"s259": "Kraftkompensation 8 für Schweißzange 2",
	"s260": "Stepper-Schweißpunktanzahl 9 für Schweißzange 2",
	"s261": "Leistungskompensation 9 für Schweißzange 2",
	"s262": "Kraftkompensation 9 für Schweißzange 2",
	"s263": "PWM-Ausgangssollwert Minimaler Primärstrom für Schweißzange 2",
	"s264": "PWM-Ausgangssollwert Stufe 1 Primärstrom für Schweißzange 2",
	"s265": "PWM-Ausgangssollwert Stufe 2 Primärstrom für Schweißzange 2",
	"s266": "PWM-Ausgangssollwert Stufe 3 Primärstrom für Schweißzange 2",
	"s267": "PWM-Ausgangssollwert Stufe 4 Primärstrom für Schweißzange 2",
	"s268": "PWM-Ausgangssollwert Stufe 5 Primärstrom für Schweißzange 2",
	"s269": "PWM-Ausgangssollwert Stufe 6 Primärstrom für Schweißzange 2",
	"s270": "PWM-Ausgangssollwert Maximaler Primärstrom für Schweißzange 2",
	"s271": "Messwert Minimaler Primärstrom für Schweißzange 2",
	"s272": "Messwert Stufe 1 Primärstrom für Schweißzange 2",
	"s273": "Messwert Stufe 2 Primärstrom für Schweißzange 2",
	"s274": "Messwert Stufe 3 Primärstrom für Schweißzange 2",
	"s275": "Messwert Stufe 4 Primärstrom für Schweißzange 2",
	"s276": "Messwert Stufe 5 Primärstrom für Schweißzange 2",
	"s277": "Messwert Stufe 6 Primärstrom für Schweißzange 2",
	"s278": "Messwert Maximaler Primärstrom für Schweißzange 2",
	"s279": "Anzeigewert Minimaler Primärstrom für Schweißzange 2",
	"s280": "Anzeigewert Stufe 1 Primärstrom für Schweißzange 2",
	"s281": "Anzeigewert Stufe 2 Primärstrom für Schweißzange 2",
	"s282": "Anzeigewert Stufe 3 Primärstrom für Schweißzange 2",
	"s283": "Anzeigewert Stufe 4 Primärstrom für Schweißzange 2",
	"s284": "Anzeigewert Stufe 5 Primärstrom für Schweißzange 2",
	"s285": "Anzeigewert Stufe 6 Primärstrom für Schweißzange 2",
	"s286": "Anzeigewert Maximaler Primärstrom für Schweißzange 2",
	"s287": "Obere 16 Bit des netzausfallsicher gespeicherten Alarm-Informationswerts des Zählers",
	"s288": "Funktionsauswahl UIR-Regelung",
	"s289": "Schweißzeitverlängerung bei UIR-Regelung",
	"s290": "Startzeitpunkt der UIR-Regelung",
	"s291": "Maximaler Stromerhöhungsprozentsatz der UIR-Regelung",
	"s292": "Maximaler Stromreduzierungsprozentsatz der UIR-Regelung",
	"s293": "Maximaler Zeiterhöhungsprozentsatz der UIR-Regelung",
	"s294": "Umrechnungskoeffizient vom Sekundärspannungs-Messwert zum Anzeigewert",
	"s295": "Funktionsauswahl UIR-Überwachung",
	"s296": "Funktionsauswahl Schweißdatenspeicherung auf SD-Karte",
	"s297": "Anzahl der Schweißdatensätze je SD-Kartendatei",
	"s298": "Anzahl der Schweißdateien je SD-Kartenordner",
	"s299": "Doppelmagnetventil-Funktion für große Öffnung beim Hängezangenschweißen",
	"s300": "Sekundärwiderstandsüberwachung: 0 = Aus, 1 = Ein",
	"s301": "Globale Auswahl der Widerstandsschwellenparameter: 0 = Aus, 1 = Ein",
	"s302": "Interne Offsetadresse",
	"s303": "DC-Zwischenkreisspannung während der Stromkalibrierung",
	"s304": "Vorhandenseinserkennung der Sekundärspannung",
	"s305": "Zeitraum",
	"s306": "Innerhalb von 30 Tagen",
	"s307": "Innerhalb von 60 Tagen",
	"s308": "Innerhalb von 90 Tagen",
	"s309": "Kurven",
	"s310": "Ungültiger Zeitraum.",
	"s311": "Aktive Kurve erfolgreich festgelegt.",
	"s312": "Die ausgewählte Kurve ist ungültig.",
	"s313": "Ungültige Kurvennummer.",
	"s314": "Die entsprechende Kurve wurde nicht gefunden. Löschen fehlgeschlagen.",
	"s315": "Löschen fehlgeschlagen.",
	"s316": "Erfolgreich gelöscht.",
	"s317": "Zu wenige Stichproben zum Erzeugen einer Referenzkurve.",
	"s318": "Aktuelle Referenzkurve auf die Steuerung herunterladen?",
	"s319": "Aktuelle Referenzkurve in der Schweißprogrammbibliothek speichern?",
	"s320": "Es wurde keine Referenzkurve erzeugt. Ein Download ist nicht möglich.",
	"s321": "Ungültige Schweißprogrammnummer (0–143).",
	"s322": "Fehler in den Kurvendaten.",
	"s323": "Die Referenzkurvendaten sind leer und können nicht gespeichert werden.",
	"s324": "Fehler bei der Verarbeitung der Referenzkurve.",
	"s325": "Fehler beim Speichern der Referenzkurve.",
	"s326": "Alarmliste",
	"s327": "Ausführung fehlgeschlagen.",
	"s328": "Ausführung erfolgreich abgeschlossen.",
	"s329": "Validierung fehlgeschlagen.",
	"s330": "Ausführung läuft ...",
	"s331": "Da der Stromschwellenmodus „Prozent“ ist, muss {{.a}} als Ganzzahl eingestellt werden. Prüfen Sie den Wert. Falls eine Änderung nicht wirksam wurde, verbinden Sie das Gerät erneut.",
	"s332": "Der Debug-Modus ist aktiv. Deaktivieren Sie ihn vor dem Verlassen.",
	"s333": "Einstellmodus des Stromalgorithmus",
	"s334": "Schnell",
	"s335": "Endpunkt",
	"s336": "Systemkonfiguration",
	"s337": "Parallele Aufgaben für Sicherung/Wiederherstellung von Geräteparametern",
	"s338": "Speicherverzeichnis des HRC-670",
	"s339": "Verbindungsport des HRC-670",
	"s340": "Systemkonfiguration anzeigen",
	"s341": "Systemkonfiguration verwalten",
	"s342": "Beim Speichern der Parameter ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"s343": "Beim Abrufen der Systemkonfiguration ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"s344": "Konfiguration erfolgreich gespeichert.",
	"s345": "Das Speicherverzeichnis des HRC-670 ist erforderlich.",
	"s346": "Der Pfad des HRC-670-Speicherverzeichnisses ist nicht vorhanden!",
	"s347": "Die Anzahl paralleler Aufgaben für Sicherung/Wiederherstellung von Geräteparametern muss eine positive Ganzzahl sein.",
	"s348": "Die Anzahl paralleler Aufgaben für Sicherung/Wiederherstellung von Geräteparametern muss im Bereich 1–8 liegen.",
	"s349": "Kompatibilitätsmodus ohne Schweißpunktzuordnung",
	"s350": "Anzeigeleuchte",
	"s351": "Aufzeichnungsstatus",
	"i001": "Datenverwaltung",
	"i002": "Daten löschen",
	"i003": "Schweißdatensätze",
	"i004": "Kurvendatensätze",
	"i005": "Alarmdatensätze",
	"i006": "UIR-Referenzkurven",
	"i007": "Daten der Schweißprogrammbibliothek",
	"i008": "Zwischengespeicherte Schweißprogrammdaten",
	"i009": "Zwischengespeicherte Systemdaten",
	"i010": "Änderungsprotokolle",
	"i011": "Systemprotokolle",
	"i012": "Warnung: Gelöschte Daten können nicht wiederhergestellt werden. Sichern Sie die Daten vor dem Löschen!",
	"i013": "Benutzer „{{.a}}“ hat die Daten von {{.b}} gelöscht.",
	"i014": "Daten erfolgreich gelöscht.",
	"i015": "Daten konnten nicht gelöscht werden.",
	"i016": "Nach Zeitraum löschen",
	"i017": "1 Monat",
	"i018": "3 Monate",
	"i019": "6 Monate",
	"i020": "1 Jahr",
	"i021": "Löschen vor:",
	"i022": "Ohne Zeitfilter löschen",
	"i023": "Benutzer „{{.a}}“ hat die Daten von {{.b}} gelöscht. Löschbereich:",
	"i024": "Automatische Sicherung der Geräteparameter",
	"i025": "Wählen Sie nach dem Aktivieren der automatischen Gerätesicherung die Sicherungszeit aus.",
	"i026": "Rollierende Datenaufbewahrung",
	"i027": "Wählen Sie nach dem Aktivieren der automatischen Bereinigung die automatisch zu löschenden Datensätze aus.",
	"i028": "Wählen Sie nach dem Aktivieren der automatischen Bereinigung den automatisch zu löschenden Zeitraum aus.",
	"i029": "Die Bereinigungsfunktion auf dieser Seite führt eine einmalige manuelle Bereinigung aus. Für die automatische Bereinigung wechseln Sie zu System -> Systemkonfiguration, aktivieren „Rollierende Datenaufbewahrung“ und speichern die Änderungen.",
	"i030": "TCP-Server",
	"i031": "SSH-Server",
	"i032": "Dauerhaft löschen",
	"i033": "Dieses Gerät löschen? Seine Daten können danach nicht wiederhergestellt werden.",
	"i034": "Eine Woche",
	"h001": "Benutzer „{{.a}}“ hat den Eintrag „{{.b}}“ der Schweißprogrammbibliothek aktualisiert (Schweißprogrammname: „{{.c}}“).",
	"h002": "Beim Abrufen der Systemprotokolldaten ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"h003": "Benutzer „{{.a}}“ hat den Eintrag „{{.b}}“ der Schweißprogrammbibliothek angelegt (Schweißprogrammname: „{{.c}}“).",
	"h004": "Benutzer „{{.a}}“ hat den Eintrag „{{.b}}“ der Schweißprogrammbibliothek gelöscht (Schweißprogrammname: „{{.c}}“).",
	"h005": "Benutzer „{{.a}}“ hat den Bereich „{{.b}}“ angelegt.",
	"h006": "Benutzer „{{.a}}“ hat den Bereich „{{.b}}“ aktualisiert.",
	"h007": "Benutzer „{{.a}}“ hat den Bereich „{{.b}}“ gelöscht.",
	"h008": "Benutzer „{{.a}}“ hat den Bereich „{{.b}}“ wiederhergestellt.",
	"h009": "Benutzer „{{.a}}“ hat das Gerät „{{.b}}“ angelegt.",
	"h010": "Benutzer „{{.a}}“ hat das Gerät „{{.b}}“ aktualisiert.",
	"h011": "Benutzer „{{.a}}“ hat das Gerät „{{.b}}“ gelöscht.",
	"h012": "Benutzer „{{.a}}“ hat das Gerät „{{.b}}“ wiederhergestellt.",
	"h013": "Benutzer „{{.a}}“ hat den Benutzer „{{.b}}“ angelegt.",
	"h014": "Benutzer „{{.a}}“ hat den Benutzer „{{.b}}“ aktualisiert.",
	"h015": "Benutzer „{{.a}}“ hat den Benutzer „{{.b}}“ gelöscht.",
	"h016": "Benutzer „{{.a}}“ hat den Benutzer „{{.b}}“ wiederhergestellt.",
	"h017": "Das Benutzerkonto „{{.b}}“ wurde nach mehr als {{.a}} falschen Anmeldepasswortversuchen für 20 Minuten gesperrt.",
	"h018": "Benutzer „{{.a}}“ hat sich erfolgreich angemeldet.",
	"h019": "Benutzer „{{.a}}“ hat die Kurvenerfassungseinstellungen des Geräts „{{.b}}“ aktualisiert.",
	"h020": "Benutzer „{{.a}}“ hat die Rolle „{{.b}}“ angelegt.",
	"h021": "Benutzer „{{.a}}“ hat die Rolle „{{.b}}“ aktualisiert.",
	"h022": "Benutzer „{{.a}}“ hat die Rolle „{{.b}}“ gelöscht.",
	"h023": "Benutzer „{{.a}}“ hat die Rolle „{{.b}}“ wiederhergestellt.",
	"h024": "Benutzer „{{.a}}“ hat die Berechtigungen der Rolle „{{.b}}“ geändert.",
	"k001": "Echtzeitüberwachung",
	"k002": "Schweißprogrammparameter",
	"k003": "Produktionsverwaltung",
	"k004": "Systemparameter",
	"k005": "Schweißdatensätze",
	"k006": "Alarmdatensätze",
	"k007": "Änderungsprotokolle",
	"k008": "Schweißpunktverwaltung",
	"k009": "Gerät",
	"k010": "Offline-Bibliothek",
	"k011": "Schweißzangenauswahl",
	"k012": "Austreibungszähler",
	"k013": "Schwelle der Austreibungserkennung",
	"k014": "Zeitfensterschwelle der Austreibung",
	"k015": "Widerstandsreferenzwert",
	"k016": "Untere Schweißwiderstandsschwelle",
	"k017": "Obere Schweißwiderstandsschwelle",
	"k018": "Ungültige Schweißprogrammnummer.",
	"k019": "Schweißprogramm „{{.a}}“ erfolgreich vom Gerät geladen.",
	"k020": "Schweißprogramm „{{.a}}“ konnte nicht vom Gerät geladen werden.",
	"k021": "Schweißprogramm „{{.a}}“ erfolgreich aus der Offline-Datenbank geladen.",
	"k022": "Schweißprogramm „{{.a}}“ konnte nicht aus der Offline-Datenbank geladen werden.",
	"k023": "Herunterladen",
	"k024": "Gerät -> Bibliothek",
	"k025": "Exportieren",
	"k026": "Importieren",
	"k027": "Kalibrierung Elektrode 1",
	"k028": "Kalibrierung Elektrode 2",
	"k029": "Kalibrierung Elektrode 3",
	"k030": "Kalibrierung Elektrode 4",
	"k031": "Kalibrierung Elektrode 5",
	"k032": "UIR-Einstellungen",
	"k033": "UIR-Kurve",
	"k034": "UIP-Rechteckdiagramm",
	"k035": "Software-Upgrade",
	"k036": "Sicherung der Systemparameter",
	"k037": "Konfiguration der Schweißmaschine",
	"k038": "Schweißmaschinentyp",
	"k039": "Standard-Punktschweißen",
	"k040": "Roboter-Punktschweißen",
	"k041": "Standard-Rollnahtschweißen",
	"k042": "Sonder-Rollnahtschweißen",
	"k043": "Hängezangenschweißen",
	"k044": "Kundenspezifisches Schweißen",
	"k045": "Buckelschweißen",
	"k046": "BYD-Hängezangenschweißen",
	"k047": "Schweißpunktbestätigung",
	"k048": "Aus",
	"k049": "Ein",
	"k050": "Transformatortyp",
	"k051": "Bestätigung Elektrodenkappenfräsen",
	"k052": "Signal „Schweißung abgeschlossen“",
	"k053": "Impulsförmig",
	"k054": "Pegel",
	"k055": "Auswahl des Stromschwellenmodus",
	"k056": "Absolutwertmodus",
	"k057": "Prozentmodus",
	"k058": "UIP-Alarmmodus",
	"k059": "Warnung",
	"k060": "Maschine stoppen",
	"k061": "Minimale DC-Zwischenkreisspannung",
	"k062": "Dauerschweißmodus",
	"k063": "Referenz-DC-Zwischenkreisspannung",
	"k064": "Konstantstromregelung",
	"k065": "Sekundär-Konstantstrom",
	"k066": "Primär-Konstantstrom",
	"k067": "Maximale Elektrodenkraft",
	"k068": "Umrichter-Ausgangsfrequenz",
	"k069": "Funktionseinstellungen",
	"k070": "HMI-Not-Halt",
	"k071": "Funktion des Proportionaldruckreglers",
	"k072": "Schweißprogrammpriorität",
	"k073": "Steuerungsbetrieb ohne HMI",
	"k074": "Grundeinstellungen",
	"k075": "Kalibrierauswahl",
	"k076": "Elektrodenkraft kalibrieren",
	"k077": "Primärstrom kalibrieren",
	"k078": "Sekundärstrom kalibrieren",
	"k079": "Kalibrierwert",
	"k080": "Sollwert (%)",
	"k081": "Messwert (kN)",
	"k082": "Funktionsauswahl",
	"k083": "UIR-Überwachung",
	"k084": "Zeitkompensation",
	"k085": "Startzeit",
	"k086": "Funktionsparameter",
	"k087": "Obere Stromregelgrenze",
	"k088": "Untere Stromregelgrenze",
	"k089": "Zeitfensterschwelle der Austreibung",
	"k090": "Schwelle der Austreibungserkennung",
	"k091": "Maximale Zeitverlängerung",
	"k092": "Sekundärspannungskoeffizient",
	"k093": "Globale Auswahl der Widerstandsschwellenparameter",
	"k094": "Sekundärwiderstandsüberwachung",
	"k095": "Untere Schweißwiderstandsschwelle",
	"k096": "Obere Schweißwiderstandsschwelle",
	"k097": "Maximale Zeitverlängerung",
	"k098": "UIR-Aufzeichnung stoppen",
	"k099": "Schweißpunktanzahl",
	"k100": "Ausgewählte Kurven",
	"k101": "Schweißzeit",
	"k102": "Schweißpunkt-Nr.",
	"k103": "Kurve löschen",
	"k104": "Referenzkurve erzeugen",
	"k105": "-> Steuerung",
	"k106": "UIP-Funktionsauswahl",
	"k107": "UIP-Referenzwert",
	"k108": "Oberes UIP-Toleranzband",
	"k109": "Unteres UIP-Toleranzband",
	"k110": "Steuerungs-Upgrade",
	"k111": "Hinweis: Die Steuerung kann nur im Bereitschaftszustand aktualisiert werden. Schalten Sie während des Upgrades die Stromversorgung nicht aus. Starten Sie die Steuerung nach Abschluss des Upgrades neu.",
	"k112": "Firmware",
	"k113": "Wählen Sie die Firmwaredatei der Steuerung aus.",
	"k114": "Datei auswählen",
	"k115": "Upgrade",
	"k116": "Werkseinstellungen wiederherstellen",
	"k117": "Hinweis: Beim Zurücksetzen der Steuerung auf Werkseinstellungen werden die vorhandenen Daten gelöscht.",
	"k118": "Optionen",
	"k119": "Systemparameter",
	"k120": "Wiederherstellen",
	"k121": "Kalibrierparameter",
	"k122": "Sekundärkreisimpedanz",
	"k123": "Schweißfreigabe",
	"k124": "Maximaler Sekundärstrom",
	"k125": "Kraftausgangsmodus",
	"k126": "Maximale Schweißzeit",
	"k127": "Maximale Impulsbreitenänderung",
	"k128": "Normale Impedanz",
	"k129": "Erhöhte Impedanz",
	"k130": "Niedrige Impedanz",
	"k131": "E/A-Steuerungsfunktion",
	"k132": "Priorität Steuerung",
	"k133": "Priorität RS-485",
	"k134": "Priorität DeviceNet",
	"k135": "Priorität Modbus TCP",
	"k136": "Priorität ABCC",
	"k137": "Priorität Betriebsmodus",
	"k138": "Priorität Programmiergerät",
	"k139": "Priorität Gültigkeitssignal",
	"k140": "Priorität Schweißprogrammgruppe",
	"k141": "UIP-Einstellungen",
	"k142": "Erfolgreich vom Gerät geladen.",
	"k143": "Erfolgreich aus der Offline-Bibliothek geladen.",
	"k144": "Laden vom Gerät fehlgeschlagen.",
	"k145": "Laden aus der Offline-Bibliothek fehlgeschlagen.",
	"k146": "Sekundärspannungserkennung",
	"k147": "Sekundärspannungserkennung",
	"k148": "UIR-Regelung",
	"k149": "Umrichterfrequenz",
	"k150": "Auswahl der Primärstromkalibrierung",
	"k151": "Systemstandard",
	"k152": "Benutzerkalibrierung",
	"k153": "Umrichterfrequenz",
	"k154": "Feinabgleichkoeffizient Primärstrom",
	"k155": "Auswahl der Sekundärstromkalibrierung",
	"k156": "PWM-Sollwert",
	"k157": "Messwert (kA)",
	"k158": "Messwert",
	"k159": "Feinabgleichkoeffizient Primärstrom",
	"k160": "Feinabgleichkoeffizient Sekundärstrom",
	"k161": "Feinabgleichkoeffizient Sekundärstrom",
	"k162": "Primärstrom-Kalibrierwert",
	"k163": "Sekundärstrom-Kalibrierwert",
	"k164": "Elektrodenkraft",
	"k165": "Primärstrom der Elektrode",
	"k166": "Sekundärstrom der Elektrode",
	"k167": "Zähler Elektrode 1",
	"k168": "Zähler Elektrode 2",
	"k169": "Elektrodenkappenfräsen Elektrode 1",
	"k170": "Elektrodenkappenfräsen Elektrode 2",
	"k171": "Werkstückinformationen",
	"k172": "Produktionslos-Nr.",
	"k173": "Bediener",
	"k174": "Schweißprogramm Start 1",
	"k175": "Schweißprogramm Start 2",
	"k176": "Suchen",
	"k177": "Anzahl der Schweißprogramm-Verknüpfungsstufen",
	"k178": "Startverzögerung bis Vorpressen",
	"k179": "Funktionsauswahl",
	"k180": "Stepper-Funktion",
	"k181": "Leistungskompensation (%)",
	"k182": "Nachschweißfunktion",
	"k183": "Prüffunktion",
	"k184": "Maximale Nachschweißanzahl",
	"k185": "Funktion Start 2",
	"k186": "Alarm Schweißpunktzähler je Werkstück",
	"k187": "Alarm Schichtproduktionszähler",
	"k188": "Zeitmessung unmittelbar nach Alarmrücksetzung starten",
	"k189": "Prozess-Schweißpunktsteuerung der Schweißzange",
	"k190": "Untere Prozess-Schweißpunktgrenze der Schweißzange",
	"k191": "Obere Prozess-Schweißpunktgrenze der Schweißzange",
	"k192": "Erkennungszeit für Schweißpunktende der Schweißzange (s)",
	"k193": "Schweißpunktanzahl je Werkstück",
	"k194": "Schichtproduktionszähler",
	"k195": "Gesamtproduktionszähler",
	"k196": "Gesamtschweißpunktzähler",
	"k197": "Aktueller Wert",
	"k198": "Auf null setzen",
	"k199": "Anzahl der Stepper-Stufen",
	"k200": "Fräsanzahl",
	"k201": "Fräsvorwarnung",
	"k202": "Aufwärtsdruck beim Elektrodenkappenfräsen",
	"k203": "Abwärtsdruck beim Elektrodenkappenfräsen",
	"k204": "Stepper-Stufe 1",
	"k205": "Stepper-Stufe 2",
	"k206": "Stepper-Stufe 3",
	"k207": "Stepper-Stufe 4",
	"k208": "Stepper-Stufe 5",
	"k209": "Stepper-Stufe 6",
	"k210": "Stepper-Stufe 7",
	"k211": "Stepper-Stufe 8",
	"k212": "Stepper-Stufe 9",
	"k213": "Werkstückname",
	"k214": "Fehler beim Laden der UIP-Kurvendaten.",
	"k215": "Fehler beim Abrufen der Einstellungen aus der Offline-Bibliothek.",
	"k216": "Fehler beim Abrufen der Einstellungen vom Gerät.",
	"k217": "Schichtproduktions-Sollwert der Schweißzange",
	"k218": "Sollwert",
	"k219": "Kraftkompensation (%)",
	"k220": "Wählen Sie einen Datumsbereich aus.",
	"k221": "Datum",
	"k222": "Uhrzeit",
	"k223": "Alarmbeschreibung",
	"k224": "Datensatz",
	"k225": "Erstellt am",
	"k226": "Fahrzeug-VIN",
	"k227": "Schweißstufe 1 (kA/ms)",
	"k228": "Schweißstufe 2 (kA/ms)",
	"k229": "Schweißstufe 3 (kA/ms)",
	"k230": "Aktive Schweißzangen-Nr.",
	"k231": "Energie (kJ)",
	"k232": "Ausgangsimpulsbreite (%)",
	"k233": "Sekundärspannung (V)",
	"k234": "Sekundärwiderstand (µΩ)",
	"k235": "UIP-Wert",
	"k236": "Alle",
	"k237": "Kein Alarm",
	"k238": "Mit Alarm",
	"k239": "Vor Änderung",
	"k240": "Nach Änderung",
	"k241": "Schweißpunkt-ID",
	"k242": "Zeilen-Nr.",
	"k243": "Kraft (N)",
	"k244": "Blechdicke (mm)",
	"k245": "Fahrzeugmodell",
	"k246": "Schweißpunktinformationen",
	"k247": "Werkstoff Blech 1",
	"k248": "Dicke Blech 1 (mm)",
	"k249": "Werkstoff Blech 2",
	"k250": "Dicke Blech 2 (mm)",
	"k251": "Werkstoff Blech 3",
	"k252": "Dicke Blech 3 (mm)",
	"k253": "Werkstoff Blech 4",
	"k254": "Dicke Blech 4 (mm)",
	"k255": "Aufgetreten",
	"k256": "Zurückgesetzt",
	"k257": "Beschreibung",
	"k258": "Fahrzeugmodellcode",
	"k259": "Schweißpunkt-Zuordnungsnummer",
	"k260": "Ungültige Abfrageparameter.",
	"k261": "Aktuelles Gerät",
	"k262": "Elektrode 1",
	"k263": "Elektrode 2",
	"k264": "Bibliothek -> Gerät",
	"k265": "Die Offline-Bibliothek ist nicht konfiguriert. Eine Synchronisierung ist nicht zulässig.",
	"k266": "Fehler der Exportfunktion.",
	"k267": "Fehler beim Lesen der Schweißprogrammdaten.",
	"k268": "Primärschlüssel",
	"k269": "Teilename",
	"k270": "Vorpresszeit (ms)",
	"k271": "Nachsetzzeit (ms)",
	"k272": "Vorschweißstrom (kA)",
	"k273": "Vorschweißzeit (ms)",
	"k274": "Kühlzeit 0 (ms)",
	"k275": "Stromanstiegszeit (ms)",
	"k276": "Strom Schweißstufe 1 (kA)",
	"k277": "Zeit Schweißstufe 1 (ms)",
	"k278": "Kühlzeit 1 (ms)",
	"k279": "Strom Schweißstufe 2 (kA)",
	"k280": "Zeit Schweißstufe 2 (ms)",
	"k281": "Kühlzeit 2 (ms)",
	"k282": "Strom Schweißstufe 3 (kA)",
	"k283": "Zeit Schweißstufe 3 (ms)",
	"k284": "Stromabfallzeit (ms)",
	"k285": "Kühlzeit 3 (ms)",
	"k286": "Nachschweißstrom (kA)",
	"k287": "Nachschweißzeit (ms)",
	"k288": "Nachhaltezeit (ms)",
	"k289": "Pausenzeit (ms)",
	"k290": "Stepper-Koeffizient",
	"k291": "Wiederholungsanzahl",
	"k292": "Aktueller Schweißpunktzähler",
	"k293": "Primärkondensatorspannung",
	"k294": "Eingangsstatus (In00–In31)",
	"k295": "Ausgangsstatus 0 (Out00–Out31)",
	"k296": "Aktueller Systembetriebsmodus",
	"k297": "Schweißpunktzähler je Werkstück für Schweißzange 1",
	"k298": "Schweißpunktzähler je Werkstück für Schweißzange 2",
	"k299": "Schichtproduktionszähler für Schweißzange 1",
	"k300": "Schichtproduktionszähler für Schweißzange 2",
	"k301": "Gesamtproduktionszähler für Schweißzange 1",
	"k302": "Gesamtproduktionszähler für Schweißzange 2",
	"k303": "Gesamtschweißpunktzähler für Schweißzange 1",
	"k304": "Gesamtschweißpunktzähler für Schweißzange 2",
	"k305": "Stepper-Stufenzähler für Schweißzange 1",
	"k306": "Stepper-Stufenzähler für Schweißzange 2",
	"k307": "Fräszähler für Schweißzange 1",
	"k308": "Fräszähler für Schweißzange 2",
	"k309": "Aktive Schweißprogramm-Nr. für Schweißzange 2",
	"k310": "Anzahl historischer Alarmdatensätze",
	"k311": "Aktive Schweißzangen-Nr.",
	"k312": "Energie",
	"k313": "Belastbarkeit",
	"k314": "Sekundärspannung",
	"k315": "Sekundärwiderstand",
	"k316": "Alarmkennzeichen",
	"k317": "Anzahl der Verknüpfungsstufen des Schweißprogramms Start 1",
	"k318": "Funktionsauswahl Startverzögerung über Vorpressen hinaus",
	"k319": "Funktionsauswahl Stepper",
	"k320": "Aufwärtsdruck beim Elektrodenkappenfräsen für Schweißzange A",
	"k321": "Funktionsauswahl Nachschweißen",
	"k322": "E/A-Funktionsauswahl",
	"k323": "Fräsdruck für Schweißzange A",
	"k324": "Erkennungszeit für Schweißpunktende der Schweißzange",
	"k325": "Anzahl der Umrichter",
	"k326": "Stromrückführungserkennung",
	"k327": "Prioritätseinstellungen der Steuerungsfunktionen",
	"k328": "Sollwert der Stepper-Stufenanzahl",
	"k329": "Stepper-Stufenzähler",
	"k330": "Sollwert der Fräsanzahl",
	"k331": "Fräszähler",
	"k332": "Schweißpunkt-Sollwert für Fräsvorwarnung",
	"k333": "Stepper-Schweißpunktanzahl 1",
	"k334": "Leistungskompensation 1",
	"k335": "Kraftkompensation 1",
	"k336": "Stepper-Schweißpunktanzahl 2",
	"k337": "Leistungskompensation 2",
	"k338": "Kraftkompensation 2",
	"k339": "Stepper-Schweißpunktanzahl 3",
	"k340": "Leistungskompensation 3",
	"k341": "Kraftkompensation 3",
	"k342": "Stepper-Schweißpunktanzahl 4",
	"k343": "Leistungskompensation 4",
	"k344": "Kraftkompensation 4",
	"k345": "Stepper-Schweißpunktanzahl 5",
	"k346": "Leistungskompensation 5",
	"k347": "Kraftkompensation 5",
	"k348": "Stepper-Schweißpunktanzahl 6",
	"k349": "Leistungskompensation 6",
	"k350": "Kraftkompensation 6",
	"k351": "Stepper-Schweißpunktanzahl 7",
	"k352": "Leistungskompensation 7",
	"k353": "Kraftkompensation 7",
	"k354": "Stepper-Schweißpunktanzahl 8",
	"k355": "Leistungskompensation 8",
	"k356": "Kraftkompensation 8",
	"k357": "Stepper-Schweißpunktanzahl 9",
	"k358": "Aufwärtsdruck beim Elektrodenkappenfräsen",
	"k359": "Abwärtsdruck beim Elektrodenkappenfräsen",
	"k360": "Schweißzangenkonfiguration",
	"k361": "Konfigurationsmodus der Schweißzange",
	"k362": "Eine Schweißzange",
	"k363": "Zwei Schweißzangen",
	"k364": "Mehrere Schweißzangen",
	"k365": "Modus „Große Schweißzangenöffnung“",
	"k366": "Dauersignal",
	"k367": "Tastsignal",
	"k368": "Elektrodenarmzustand bei Spannungsabschaltung",
	"k369": "Kleine Öffnung",
	"k370": "Große Öffnung",
	"k371": "Ventiltyp für große Schweißzangenöffnung",
	"k372": "Einfachmagnetventil",
	"k373": "Doppelmagnetventil",
	"k374": "Verzögerter Start der kleinen Öffnung",
	"k375": "Schweißen bei unzureichendem Kühlwasser zulassen",
	"k376": "Wasserdurchflussüberwachung für Schweißzange 2",
	"k377": "Benutzer „{{.a}}“ hat die Kurvenerfassungseinstellungen für Geräte-ID „{{.b}}“ aktualisiert.",
	"k378": "Benutzer „{{.a}}“ hat die DIP-Schweißprogrammbibliothek „{{.c}}“ auf Gerät „{{.b}}“ heruntergeladen.",
	"k379": "X",
	"k380": "Y",
	"k381": "Z",
	"k382": "Die Schweißpunkt-Zuordnungsnummer ist bereits vorhanden.",
	"k383": "Schweißpunkt erfolgreich hinzugefügt.",
	"k384": "Schweißpunkt konnte nicht hinzugefügt werden.",
	"k385": "Schweißpunkt erfolgreich aktualisiert.",
	"k386": "Schweißpunkt konnte nicht aktualisiert werden.",
	"k387": "Erweiterte Schweißpunktinformationen konnten nicht gespeichert werden.",
	"k388": "Erweiterte Schweißpunktinformationen konnten nicht abgefragt werden.",
	"k389": "Download fehlgeschlagen. Gerät {{.a}} ist möglicherweise offline.",
	"k390": "Die Schweißpunktanzahl ist ungültig oder größer als 2000.",
	"k391": "Die UIR-Aufzeichnung wurde noch nicht gestartet.",
	"k392": "Die UIR-Aufzeichnung wurde bereits gestartet. Starten Sie sie nicht erneut.",
	"k393": "UIR-Aufzeichnung starten",
	"k394": "UIR-Aufzeichnung stoppen",
	"k395": "Fehler bei der Datenabfrage.",
	"k396": "Ausgewählte Kurve",
	"k397": "Referenzkurve erzeugen",
	"k398": "-> Steuerung",
	"k399": "-> PC",
	"k400": "Kurvenpaket",
	"k401": "Erfolgreich geladen.",
	"k402": "Es liegt kein Alarm zum Zurücksetzen vor.",
	"k403": "Fehler beim Lesen der Systemparameter.",
	"k404": "Der Stromschwellenmodus in der Importdatei stimmt nicht mit dem Zielgerät überein.",
	"w001": "Strom Schweißstufe 1 über Grenzwert",
	"w002": "Strom Schweißstufe 1 unter Grenzwert",
	"w003": "Strom Schweißstufe 2 über Grenzwert",
	"w004": "Strom Schweißstufe 2 unter Grenzwert",
	"w005": "Strom Schweißstufe 3 über Grenzwert",
	"w006": "Strom Schweißstufe 3 unter Grenzwert",
	"w007": "IGBT-Störung",
	"w008": "Not-Halt-Störung",
	"w009": "Übertemperatur Transformator 1",
	"w010": "Übertemperatur Thyristor",
	"w011": "Fehler Wasserdurchflussschalter",
	"w012": "Fehler Luftdruckschalter",
	"w013": "Zeitüberschreitung Schweißfreigabe",
	"w014": "Zeitüberschreitung programmierbarer Eingang 1",
	"w015": "Zeitüberschreitung programmierbarer Eingang 2",
	"w016": "Zeitüberschreitung programmierbarer Eingang 3",
	"w017": "Fehler der Speicherparametertabelle",
	"w018": "Zeitüberschreitung beim Laden des Primärkondensators",
	"w019": "Fußschalter beim Einschalten des Systems geschlossen",
	"w020": "Primärkondensatorspannung zu niedrig",
	"w021": "Fehler beim Schreiben der FRAM-Daten",
	"w022": "Einstellfehler Vorpresszeit",
	"w023": "RS-485-Kommunikationsstörung",
	"w024": "Hängezangenschweißen: Alarm Wasserdurchflussschalter Schweißzange 2",
	"w025": "Sicherheitslichtvorhang ausgelöst",
	"w026": "Einstellfehler Transformatortyp",
	"w027": "Einstellfehler Konstantstrommodus",
	"w028": "Einstellfehler Sekundärstrombereich",
	"w029": "Alarm „Schweißen gesperrt“",
	"w030": "Stromausgangsschutz aktiv",
	"w031": "Übertemperatur Transformator 2",
	"w032": "Fehler der Stromrückführung",
	"w033": "Aktueller Schweißpunktzähler von Schweißzange 1 hat den Sollwert je Werkstück erreicht",
	"w034": "Ist-Schweißpunktanzahl von Schweißzange 1 über Obergrenze je Werkstück",
	"w035": "Ist-Schweißpunktanzahl von Schweißzange 1 unter Untergrenze je Werkstück",
	"w036": "Schichtproduktionszähler von Schweißzange 1 hat den Sollwert erreicht",
	"w037": "Fräsvorwarnung Schweißzange 1",
	"w038": "Fräsalarm Schweißzange 1",
	"w039": "Elektrodenwechselalarm Schweißzange 1",
	"w040": "Elektrodenwechsel-Vorwarnung Schweißzange 1",
	"w041": "Reserviert 01",
	"w042": "Aktueller Schweißpunktzähler von Schweißzange 2 hat den Sollwert je Werkstück erreicht",
	"w043": "Ist-Schweißpunktanzahl von Schweißzange 2 über Obergrenze je Werkstück",
	"w044": "Ist-Schweißpunktanzahl von Schweißzange 2 unter Untergrenze je Werkstück",
	"w045": "Schichtproduktionszähler von Schweißzange 2 hat den Sollwert erreicht",
	"w046": "Fräsvorwarnung Schweißzange 2",
	"w047": "Fräsalarm Schweißzange 2",
	"w048": "Elektrodenwechselalarm Schweißzange 2",
	"w049": "Elektrodenwechsel-Vorwarnung Schweißzange 2",
	"w050": "Reserviert 49",
	"w051": "Reserviert 50",
	"w052": "Reserviert 51",
	"w053": "Reserviert 52",
	"w054": "Reserviert 53",
	"w055": "Reserviert 54",
	"w056": "Reserviert 55",
	"w057": "Reserviert 56",
	"w058": "Reserviert 57",
	"w059": "Reserviert 58",
	"w060": "Reserviert 59",
	"w061": "RTC-Fehler",
	"w062": "Schreibfehler der SD-Karte",
	"w063": "Fehler der Kalibrierparameter",
	"w164": "Fehler der Stepper-Parameter",
	"w064": "Schlechter Kontakt der Stromrückführungsleitung",
	"w065": "Schweißwiderstand zu hoch",
	"w066": "Schweißwiderstand zu niedrig",
	"w067": "Störung der Sekundärspannungsleitung",
	"w168": "UIP zu niedrig",
	"w069": "UIP zu hoch",
	"w068": "Störung der adaptiven Schweißregelung",
	"w097": "Austreibungsalarm",
	"w098": "Ausgangsimpulsbreite zu hoch",
	"w099": "UIP zu niedrig",
	"w100": "UIP zu hoch",
	"z001": "{{.a}} (gültiger Bereich: {{.b}}–{{.c}}{{.d}}); Zielsollwert: {{.e}}",
	"z002": "Keine Gleitkommazahl: {{.a}}",
	"z003": "Keine Zeichenfolge: {{.a}}",
	"z004": "Erwartete Länge {{.a}}; tatsächliche Länge {{.b}}.",
	"z005": "Die Steuerung implementiert die Methode {{.a}} nicht.",
	"z006": "Offline",
	"z007": "Online",
	"z008": "Störung",
	"z009": "Gelöscht",
	"z010": "Ungültige Eingabe für {{.a}}.",
	"z011": "Fehler bei der Eingabevalidierung.",
	"z012": "Alarmdatensätze",
	"z013": "Debug-Programm",
	"z014": "Datenbankverwaltung",
	"z015": "Änderungsprotokolle",
	"z016": "Produktionsverwaltung",
	"z017": "Schweißprogrammparameter",
	"z018": "Schweißdatensätze",
	"z019": "Echtzeitüberwachung",
	"z020": "Systemparameter",
	"z021": "Nicht aktiviert",
	"z022": "Aktiv",
	"z023": "Gesperrt",
	"z024": "Gelöscht",
	"z025": "Administrator",
	"z026": "Bediener",
	"z027": "Betrachter",
	"z028": "Die Schweißprogrammnummer liegt außerhalb des Bereichs (0–959).",
	"z029": "Die Schweißprogrammnummer liegt außerhalb des Bereichs (0–63).",
	"z030": "Steuerung 1 ist keine gültige Ganzzahl.",
	"z031": "Steuerung 2 ist keine gültige Ganzzahl.",
	"z032": "Schweißprogramm-Nr. 1 ist keine gültige Ganzzahl.",
	"z033": "Schweißprogramm-Nr. 2 ist keine gültige Ganzzahl.",
	"z034": "Dasselbe Schweißprogramm kann nicht mit sich selbst verglichen werden.",
	"z035": "Werkstückname",
	"z036": "Produktionslos-Nr.",
	"z037": "Bediener",
	"z038": "Fehler beim Abfragen des Offline-Schweißprogramms.",
	"z039": "Keine Ganzzahl: {{.a}}",
	"z040": "Verbindung wird wiederhergestellt ...",
	"g001": "Gesamtschweißpunktzähler für Schweißzange 3",
	"g002": "Gesamtschweißpunktzähler für Schweißzange 4",
	"g003": "Gesamtschweißpunktzähler für Schweißzange 5",
	"g004": "Sollwert der Stepper-Stufenanzahl für Schweißzange 3",
	"g005": "Sollwert der Fräsanzahl für Schweißzange 3",
	"g006": "Schweißpunkt-Sollwert für Fräsvorwarnung der Schweißzange 3",
	"g007": "Stepper-Stufenzähler für Schweißzange 3",
	"g008": "Fräszähler für Schweißzange 3",
	"g009": "Sollwert der Stepper-Stufenanzahl für Schweißzange 4",
	"g010": "Sollwert der Fräsanzahl für Schweißzange 4",
	"g011": "Schweißpunkt-Sollwert für Fräsvorwarnung der Schweißzange 4",
	"g012": "Stepper-Stufenzähler für Schweißzange 4",
	"g013": "Fräszähler für Schweißzange 4",
	"g014": "Sollwert der Stepper-Stufenanzahl für Schweißzange 5",
	"g015": "Sollwert der Fräsanzahl für Schweißzange 5",
	"g016": "Schweißpunkt-Sollwert für Fräsvorwarnung der Schweißzange 5",
	"g017": "Stepper-Stufenzähler für Schweißzange 5",
	"g018": "Fräszähler für Schweißzange 5",
	"g019": "Stepper-Schweißpunktanzahl 1 für Schweißzange 3",
	"g020": "Leistungskompensation 1 für Schweißzange 3",
	"g021": "Kraftkompensation 1 für Schweißzange 3",
	"g022": "Stepper-Schweißpunktanzahl 2 für Schweißzange 3",
	"g023": "Leistungskompensation 2 für Schweißzange 3",
	"g024": "Kraftkompensation 2 für Schweißzange 3",
	"g025": "Stepper-Schweißpunktanzahl 3 für Schweißzange 3",
	"g026": "Leistungskompensation 3 für Schweißzange 3",
	"g027": "Kraftkompensation 3 für Schweißzange 3",
	"g028": "Stepper-Schweißpunktanzahl 4 für Schweißzange 3",
	"g029": "Leistungskompensation 4 für Schweißzange 3",
	"g030": "Kraftkompensation 4 für Schweißzange 3",
	"g031": "Stepper-Schweißpunktanzahl 5 für Schweißzange 3",
	"g032": "Leistungskompensation 5 für Schweißzange 3",
	"g033": "Kraftkompensation 5 für Schweißzange 3",
	"g034": "Stepper-Schweißpunktanzahl 6 für Schweißzange 3",
	"g035": "Leistungskompensation 6 für Schweißzange 3",
	"g036": "Kraftkompensation 6 für Schweißzange 3",
	"g037": "Stepper-Schweißpunktanzahl 7 für Schweißzange 3",
	"g038": "Leistungskompensation 7 für Schweißzange 3",
	"g039": "Kraftkompensation 7 für Schweißzange 3",
	"g040": "Stepper-Schweißpunktanzahl 8 für Schweißzange 3",
	"g041": "Leistungskompensation 8 für Schweißzange 3",
	"g042": "Kraftkompensation 8 für Schweißzange 3",
	"g043": "Stepper-Schweißpunktanzahl 9 für Schweißzange 3",
	"g044": "Leistungskompensation 9 für Schweißzange 3",
	"g045": "Kraftkompensation 9 für Schweißzange 3",
	"g046": "Stepper-Schweißpunktanzahl 1 für Schweißzange 4",
	"g047": "Leistungskompensation 1 für Schweißzange 4",
	"g048": "Kraftkompensation 1 für Schweißzange 4",
	"g049": "Stepper-Schweißpunktanzahl 2 für Schweißzange 4",
	"g050": "Leistungskompensation 2 für Schweißzange 4",
	"g051": "Kraftkompensation 2 für Schweißzange 4",
	"g052": "Stepper-Schweißpunktanzahl 3 für Schweißzange 4",
	"g053": "Leistungskompensation 3 für Schweißzange 4",
	"g054": "Kraftkompensation 3 für Schweißzange 4",
	"g055": "Stepper-Schweißpunktanzahl 4 für Schweißzange 4",
	"g056": "Leistungskompensation 4 für Schweißzange 4",
	"g057": "Kraftkompensation 4 für Schweißzange 4",
	"g058": "Stepper-Schweißpunktanzahl 5 für Schweißzange 4",
	"g059": "Leistungskompensation 5 für Schweißzange 4",
	"g060": "Kraftkompensation 5 für Schweißzange 4",
	"g061": "Stepper-Schweißpunktanzahl 6 für Schweißzange 4",
	"g062": "Leistungskompensation 6 für Schweißzange 4",
	"g063": "Kraftkompensation 6 für Schweißzange 4",
	"g064": "Stepper-Schweißpunktanzahl 7 für Schweißzange 4",
	"g065": "Leistungskompensation 7 für Schweißzange 4",
	"g066": "Kraftkompensation 7 für Schweißzange 4",
	"g067": "Stepper-Schweißpunktanzahl 8 für Schweißzange 4",
	"g068": "Leistungskompensation 8 für Schweißzange 4",
	"g069": "Kraftkompensation 8 für Schweißzange 4",
	"g070": "Stepper-Schweißpunktanzahl 9 für Schweißzange 4",
	"g071": "Leistungskompensation 9 für Schweißzange 4",
	"g072": "Kraftkompensation 9 für Schweißzange 4",
	"g073": "Stepper-Schweißpunktanzahl 1 für Schweißzange 5",
	"g074": "Leistungskompensation 1 für Schweißzange 5",
	"g075": "Kraftkompensation 1 für Schweißzange 5",
	"g076": "Stepper-Schweißpunktanzahl 2 für Schweißzange 5",
	"g077": "Leistungskompensation 2 für Schweißzange 5",
	"g078": "Kraftkompensation 2 für Schweißzange 5",
	"g079": "Stepper-Schweißpunktanzahl 3 für Schweißzange 5",
	"g080": "Leistungskompensation 3 für Schweißzange 5",
	"g081": "Kraftkompensation 3 für Schweißzange 5",
	"g082": "Stepper-Schweißpunktanzahl 4 für Schweißzange 5",
	"g083": "Leistungskompensation 4 für Schweißzange 5",
	"g084": "Kraftkompensation 4 für Schweißzange 5",
	"g085": "Stepper-Schweißpunktanzahl 5 für Schweißzange 5",
	"g086": "Leistungskompensation 5 für Schweißzange 5",
	"g087": "Kraftkompensation 5 für Schweißzange 5",
	"g088": "Stepper-Schweißpunktanzahl 6 für Schweißzange 5",
	"g089": "Leistungskompensation 6 für Schweißzange 5",
	"g090": "Kraftkompensation 6 für Schweißzange 5",
	"g091": "Stepper-Schweißpunktanzahl 7 für Schweißzange 5",
	"g092": "Leistungskompensation 7 für Schweißzange 5",
	"g093": "Kraftkompensation 7 für Schweißzange 5",
	"g094": "Stepper-Schweißpunktanzahl 8 für Schweißzange 5",
	"g095": "Leistungskompensation 8 für Schweißzange 5",
	"g096": "Kraftkompensation 8 für Schweißzange 5",
	"g097": "Stepper-Schweißpunktanzahl 9 für Schweißzange 5",
	"g098": "Leistungskompensation 9 für Schweißzange 5",
	"g099": "Kraftkompensation 9 für Schweißzange 5",
	"g100": "Feinabgleichparameter Sekundär-Konstantstrom für Schweißzange 3",
	"g101": "Feinabgleichparameter Primär-Konstantstrom für Schweißzange 4",
	"g102": "Feinabgleichparameter Sekundär-Konstantstrom für Schweißzange 4",
	"g103": "Feinabgleichparameter Primär-Konstantstrom für Schweißzange 5",
	"g104": "Feinabgleichparameter Sekundär-Konstantstrom für Schweißzange 5",
	"g105": "PWM-Ausgangssollwert Minimaler Primärstrom für Schweißzange 3",
	"g106": "PWM-Ausgangssollwert Stufe 1 Primärstrom für Schweißzange 3",
	"g107": "PWM-Ausgangssollwert Stufe 2 Primärstrom für Schweißzange 3",
	"g108": "PWM-Ausgangssollwert Stufe 3 Primärstrom für Schweißzange 3",
	"g109": "PWM-Ausgangssollwert Stufe 4 Primärstrom für Schweißzange 3",
	"g110": "PWM-Ausgangssollwert Stufe 5 Primärstrom für Schweißzange 3",
	"g111": "PWM-Ausgangssollwert Stufe 6 Primärstrom für Schweißzange 3",
	"g112": "PWM-Ausgangssollwert Maximaler Primärstrom für Schweißzange 3",
	"g113": "Messwert Minimaler Primärstrom für Schweißzange 3",
	"g114": "Messwert Stufe 1 Primärstrom für Schweißzange 3",
	"g115": "Messwert Stufe 2 Primärstrom für Schweißzange 3",
	"g116": "Messwert Stufe 3 Primärstrom für Schweißzange 3",
	"g117": "Messwert Stufe 4 Primärstrom für Schweißzange 3",
	"g118": "Messwert Stufe 5 Primärstrom für Schweißzange 3",
	"g119": "Messwert Stufe 6 Primärstrom für Schweißzange 3",
	"g120": "Messwert Maximaler Primärstrom für Schweißzange 3",
	"g121": "Anzeigewert Minimaler Primärstrom für Schweißzange 3",
	"g122": "Anzeigewert Stufe 1 Primärstrom für Schweißzange 3",
	"g123": "Anzeigewert Stufe 2 Primärstrom für Schweißzange 3",
	"g124": "Anzeigewert Stufe 3 Primärstrom für Schweißzange 3",
	"g125": "Anzeigewert Stufe 4 Primärstrom für Schweißzange 3",
	"g126": "Anzeigewert Stufe 5 Primärstrom für Schweißzange 3",
	"g127": "Anzeigewert Stufe 6 Primärstrom für Schweißzange 3",
	"g128": "Anzeigewert Maximaler Primärstrom für Schweißzange 3",
	"g129": "PWM-Ausgangssollwert Minimaler Sekundärstrom für Schweißzange 3",
	"g130": "PWM-Ausgangssollwert Stufe 1 Sekundärstrom für Schweißzange 3",
	"g131": "PWM-Ausgangssollwert Stufe 2 Sekundärstrom für Schweißzange 3",
	"g132": "PWM-Ausgangssollwert Stufe 3 Sekundärstrom für Schweißzange 3",
	"g133": "PWM-Ausgangssollwert Stufe 4 Sekundärstrom für Schweißzange 3",
	"g134": "PWM-Ausgangssollwert Stufe 5 Sekundärstrom für Schweißzange 3",
	"g135": "PWM-Ausgangssollwert Stufe 6 Sekundärstrom für Schweißzange 3",
	"g136": "PWM-Ausgangssollwert Maximaler Sekundärstrom für Schweißzange 3",
	"g137": "Messwert Minimaler Sekundärstrom für Schweißzange 3",
	"g138": "Messwert Stufe 1 Sekundärstrom für Schweißzange 3",
	"g139": "Messwert Stufe 2 Sekundärstrom für Schweißzange 3",
	"g140": "Messwert Stufe 3 Sekundärstrom für Schweißzange 3",
	"g141": "Messwert Stufe 4 Sekundärstrom für Schweißzange 3",
	"g142": "Messwert Stufe 5 Sekundärstrom für Schweißzange 3",
	"g143": "Messwert Stufe 6 Sekundärstrom für Schweißzange 3",
	"g144": "Messwert Maximaler Sekundärstrom für Schweißzange 3",
	"g145": "Anzeigewert Minimaler Sekundärstrom für Schweißzange 3",
	"g146": "Anzeigewert Stufe 1 Sekundärstrom für Schweißzange 3",
	"g147": "Anzeigewert Stufe 2 Sekundärstrom für Schweißzange 3",
	"g148": "Anzeigewert Stufe 3 Sekundärstrom für Schweißzange 3",
	"g149": "Anzeigewert Stufe 4 Sekundärstrom für Schweißzange 3",
	"g150": "Anzeigewert Stufe 5 Sekundärstrom für Schweißzange 3",
	"g151": "Anzeigewert Stufe 6 Sekundärstrom für Schweißzange 3",
	"g152": "Anzeigewert Maximaler Sekundärstrom für Schweißzange 3",
	"g153": "PWM-Ausgangssollwert Minimaler Primärstrom für Schweißzange 4",
	"g154": "PWM-Ausgangssollwert Stufe 1 Primärstrom für Schweißzange 4",
	"g155": "PWM-Ausgangssollwert Stufe 2 Primärstrom für Schweißzange 4",
	"g156": "PWM-Ausgangssollwert Stufe 3 Primärstrom für Schweißzange 4",
	"g157": "PWM-Ausgangssollwert Stufe 4 Primärstrom für Schweißzange 4",
	"g158": "PWM-Ausgangssollwert Stufe 5 Primärstrom für Schweißzange 4",
	"g159": "PWM-Ausgangssollwert Stufe 6 Primärstrom für Schweißzange 4",
	"g160": "PWM-Ausgangssollwert Maximaler Primärstrom für Schweißzange 4",
	"g161": "Messwert Minimaler Primärstrom für Schweißzange 4",
	"g162": "Messwert Stufe 1 Primärstrom für Schweißzange 4",
	"g163": "Messwert Stufe 2 Primärstrom für Schweißzange 4",
	"g164": "Messwert Stufe 3 Primärstrom für Schweißzange 4",
	"g165": "Messwert Stufe 4 Primärstrom für Schweißzange 4",
	"g166": "Messwert Stufe 5 Primärstrom für Schweißzange 4",
	"g167": "Messwert Stufe 6 Primärstrom für Schweißzange 4",
	"g168": "Messwert Maximaler Primärstrom für Schweißzange 4",
	"g169": "Anzeigewert Minimaler Primärstrom für Schweißzange 4",
	"g170": "Anzeigewert Stufe 1 Primärstrom für Schweißzange 4",
	"g171": "Anzeigewert Stufe 2 Primärstrom für Schweißzange 4",
	"g172": "Anzeigewert Stufe 3 Primärstrom für Schweißzange 4",
	"g173": "Anzeigewert Stufe 4 Primärstrom für Schweißzange 4",
	"g174": "Anzeigewert Stufe 5 Primärstrom für Schweißzange 4",
	"g175": "Anzeigewert Stufe 6 Primärstrom für Schweißzange 4",
	"g176": "Anzeigewert Maximaler Primärstrom für Schweißzange 4",
	"g177": "PWM-Ausgangssollwert Minimaler Sekundärstrom für Schweißzange 4",
	"g178": "PWM-Ausgangssollwert Stufe 1 Sekundärstrom für Schweißzange 4",
	"g179": "PWM-Ausgangssollwert Stufe 2 Sekundärstrom für Schweißzange 4",
	"g180": "PWM-Ausgangssollwert Stufe 3 Sekundärstrom für Schweißzange 4",
	"g181": "PWM-Ausgangssollwert Stufe 4 Sekundärstrom für Schweißzange 4",
	"g182": "PWM-Ausgangssollwert Stufe 5 Sekundärstrom für Schweißzange 4",
	"g183": "PWM-Ausgangssollwert Stufe 6 Sekundärstrom für Schweißzange 4",
	"g184": "PWM-Ausgangssollwert Maximaler Sekundärstrom für Schweißzange 4",
	"g185": "Messwert Minimaler Sekundärstrom für Schweißzange 4",
	"g186": "Messwert Stufe 1 Sekundärstrom für Schweißzange 4",
	"g187": "Messwert Stufe 2 Sekundärstrom für Schweißzange 4",
	"g188": "Messwert Stufe 3 Sekundärstrom für Schweißzange 4",
	"g189": "Messwert Stufe 4 Sekundärstrom für Schweißzange 4",
	"g190": "Messwert Stufe 5 Sekundärstrom für Schweißzange 4",
	"g191": "Messwert Stufe 6 Sekundärstrom für Schweißzange 4",
	"g192": "Messwert Maximaler Sekundärstrom für Schweißzange 4",
	"g193": "Anzeigewert Minimaler Sekundärstrom für Schweißzange 4",
	"g194": "Anzeigewert Stufe 1 Sekundärstrom für Schweißzange 4",
	"g195": "Anzeigewert Stufe 2 Sekundärstrom für Schweißzange 4",
	"g196": "Anzeigewert Stufe 3 Sekundärstrom für Schweißzange 4",
	"g197": "Anzeigewert Stufe 4 Sekundärstrom für Schweißzange 4",
	"g198": "Anzeigewert Stufe 5 Sekundärstrom für Schweißzange 4",
	"g199": "Anzeigewert Stufe 6 Sekundärstrom für Schweißzange 4",
	"g200": "Anzeigewert Maximaler Sekundärstrom für Schweißzange 4",
	"g201": "PWM-Ausgangssollwert Minimaler Primärstrom für Schweißzange 5",
	"g202": "PWM-Ausgangssollwert Stufe 1 Primärstrom für Schweißzange 5",
	"g203": "PWM-Ausgangssollwert Stufe 2 Primärstrom für Schweißzange 5",
	"g204": "PWM-Ausgangssollwert Stufe 3 Primärstrom für Schweißzange 5",
	"g205": "PWM-Ausgangssollwert Stufe 4 Primärstrom für Schweißzange 5",
	"g206": "PWM-Ausgangssollwert Stufe 5 Primärstrom für Schweißzange 5",
	"g207": "PWM-Ausgangssollwert Stufe 6 Primärstrom für Schweißzange 5",
	"g208": "PWM-Ausgangssollwert Maximaler Primärstrom für Schweißzange 5",
	"g209": "Messwert Minimaler Primärstrom für Schweißzange 5",
	"g210": "Messwert Stufe 1 Primärstrom für Schweißzange 5",
	"g211": "Messwert Stufe 2 Primärstrom für Schweißzange 5",
	"g212": "Messwert Stufe 3 Primärstrom für Schweißzange 5",
	"g213": "Messwert Stufe 4 Primärstrom für Schweißzange 5",
	"g214": "Messwert Stufe 5 Primärstrom für Schweißzange 5",
	"g215": "Messwert Stufe 6 Primärstrom für Schweißzange 5",
	"g216": "Messwert Maximaler Primärstrom für Schweißzange 5",
	"g217": "Anzeigewert Minimaler Primärstrom für Schweißzange 5",
	"g218": "Anzeigewert Stufe 1 Primärstrom für Schweißzange 5",
	"g219": "Anzeigewert Stufe 2 Primärstrom für Schweißzange 5",
	"g220": "Anzeigewert Stufe 3 Primärstrom für Schweißzange 5",
	"g221": "Anzeigewert Stufe 4 Primärstrom für Schweißzange 5",
	"g222": "Anzeigewert Stufe 5 Primärstrom für Schweißzange 5",
	"g223": "Anzeigewert Stufe 6 Primärstrom für Schweißzange 5",
	"g224": "Anzeigewert Maximaler Primärstrom für Schweißzange 5",
	"g225": "PWM-Ausgangssollwert Minimaler Sekundärstrom für Schweißzange 5",
	"g226": "PWM-Ausgangssollwert Stufe 1 Sekundärstrom für Schweißzange 5",
	"g227": "PWM-Ausgangssollwert Stufe 2 Sekundärstrom für Schweißzange 5",
	"g228": "PWM-Ausgangssollwert Stufe 3 Sekundärstrom für Schweißzange 5",
	"g229": "PWM-Ausgangssollwert Stufe 4 Sekundärstrom für Schweißzange 5",
	"g230": "PWM-Ausgangssollwert Stufe 5 Sekundärstrom für Schweißzange 5",
	"g231": "PWM-Ausgangssollwert Stufe 6 Sekundärstrom für Schweißzange 5",
	"g232": "PWM-Ausgangssollwert Maximaler Sekundärstrom für Schweißzange 5",
	"g233": "Messwert Minimaler Sekundärstrom für Schweißzange 5",
	"g234": "Messwert Stufe 1 Sekundärstrom für Schweißzange 5",
	"g235": "Messwert Stufe 2 Sekundärstrom für Schweißzange 5",
	"g236": "Messwert Stufe 3 Sekundärstrom für Schweißzange 5",
	"g237": "Messwert Stufe 4 Sekundärstrom für Schweißzange 5",
	"g238": "Messwert Stufe 5 Sekundärstrom für Schweißzange 5",
	"g239": "Messwert Stufe 6 Sekundärstrom für Schweißzange 5",
	"g240": "Messwert Maximaler Sekundärstrom für Schweißzange 5",
	"g241": "Anzeigewert Minimaler Sekundärstrom für Schweißzange 5",
	"g242": "Anzeigewert Stufe 1 Sekundärstrom für Schweißzange 5",
	"g243": "Anzeigewert Stufe 2 Sekundärstrom für Schweißzange 5",
	"g244": "Anzeigewert Stufe 3 Sekundärstrom für Schweißzange 5",
	"g245": "Anzeigewert Stufe 4 Sekundärstrom für Schweißzange 5",
	"g246": "Anzeigewert Stufe 5 Sekundärstrom für Schweißzange 5",
	"g247": "Anzeigewert Stufe 6 Sekundärstrom für Schweißzange 5",
	"g248": "Anzeigewert Maximaler Sekundärstrom für Schweißzange 5",
	"g249": "Feinabgleichparameter Primär-Konstantstrom für Schweißzange 3",
	"g250": "Nicht definierter Typ: {{.a}}",
	"g251": "Ausgangssollwert Elektrodenkraftstufe 1 für Schweißzange 3",
	"g252": "Ausgangssollwert Elektrodenkraftstufe 2 für Schweißzange 3",
	"g253": "Angezeigter Messwert Elektrodenkraftstufe 1 für Schweißzange 3",
	"g254": "Angezeigter Messwert Elektrodenkraftstufe 2 für Schweißzange 3",
	"g255": "Ausgangssollwert Elektrodenkraftstufe 1 für Schweißzange 4",
	"g256": "Ausgangssollwert Elektrodenkraftstufe 2 für Schweißzange 4",
	"g257": "Angezeigter Messwert Elektrodenkraftstufe 1 für Schweißzange 4",
	"g258": "Angezeigter Messwert Elektrodenkraftstufe 2 für Schweißzange 4",
	"g259": "Ausgangssollwert Elektrodenkraftstufe 1 für Schweißzange 5",
	"g260": "Ausgangssollwert Elektrodenkraftstufe 2 für Schweißzange 5",
	"g261": "Angezeigter Messwert Elektrodenkraftstufe 1 für Schweißzange 5",
	"g262": "Angezeigter Messwert Elektrodenkraftstufe 2 für Schweißzange 5",
	"d001": "Aktualisierungsanzahl",
	"d002": "Die Schweißpunkt-Zuordnungsnummer ist erforderlich und muss eine Ganzzahl sein.",
	"d003": "Die Schweißprogrammnummer ist erforderlich und muss eine Ganzzahl sein.",
	"d004": "Die Kraft ist erforderlich und muss eine Ganzzahl sein.",
	"d005": "Die Blechdicke ist erforderlich und muss eine Dezimalzahl sein (gültiger Bereich: 0–99999,99).",
	"d006": "X ist erforderlich und muss eine Dezimalzahl sein (gültiger Bereich: 0–999999,9999999999).",
	"d007": "Y ist erforderlich und muss eine Dezimalzahl sein (gültiger Bereich: 0–999999,9999999999).",
	"d008": "Z ist erforderlich und muss eine Dezimalzahl sein (gültiger Bereich: 0–999999,9999999999).",
	"d009": "Die Dicke von Blech 1 muss eine Dezimalzahl sein (gültiger Bereich: 0–99999,99).",
	"d010": "Die Dicke von Blech 2 muss eine Dezimalzahl sein (gültiger Bereich: 0–99999,99).",
	"d011": "Die Dicke von Blech 3 muss eine Dezimalzahl sein (gültiger Bereich: 0–99999,99).",
	"d012": "Die Dicke von Blech 4 muss eine Dezimalzahl sein (gültiger Bereich: 0–99999,99).",
	"d013": "Gelöschte Daten können nicht wiederhergestellt werden. Daten löschen?",
	"d014": "Systemparameter-Datensätze",
	"d015": "Datensätze der Schweißpunktverwaltung",
	"d016": "Vorgangstyp",
	"d017": "Hinzufügen",
	"d018": "Ändern",
	"d019": "Parametervergleich",
	"d020": "Der Bediener ist nicht vorhanden. Die Abfrage kann nicht durchgeführt werden.",
	"d021": "Der Sollwert fehlt oder ist ungültig.",
	"d022": "Importanzahl",
	"d023": "Anzahl wird berechnet",
	"d024": "Validierungsanzahl",
	"d025": "Löschanzahl",
	"d026": "Downloadanzahl",
	"d027": "Daten erfolgreich gelöscht.",
	"d028": "Daten konnten nicht gelöscht werden.",
	"d029": "Schweißpunkte aktualisieren",
	"d030": "Schweißpunkte für die ausgewählten Geräte aktualisieren?",
	"d031": "Beim Aktualisieren der Schweißpunkte ist ein Fehler aufgetreten. Der Vorgang kann nicht durchgeführt werden.",
	"d032": "Aktualisierung der Schweißpunkte abgebrochen.",
	"d033": "Das Gerät ist offline. Dieser Vorgang kann nicht durchgeführt werden.",
	"d034": "Schweißpunkte erfolgreich aktualisiert.",
	"d035": "Übersicht des Fortschritts der Schweißpunktaktualisierung",
	"d036": "Details zur Schweißpunktaktualisierung",
	"d037": "Fortschritt der Schweißpunktaktualisierung",
	"d038": "Schweißpunkte werden aktualisiert",
	"d039": "Aktualisierung der Schweißpunkte fehlgeschlagen.",
	"d040": "Durch Abbrechen der Schweißpunktaktualisierung werden alle nachfolgenden Vorgänge gestoppt. Fortfahren?",
	"d041": "Die Schweißpunktaufgabe wurde erneut gestartet.",
	"e001": "Austreibungsstatistik",
	"e002": "Austreibungsstatistik anzeigen",
	"e003": "Austreibungsstatistik verwalten",
	"e004": "Abfragedimension",
	"e005": "Schweißpunkt",
	"e006": "Ungültige Abfragedimension.",
	"e007": "Austreibungszähler",
	"e008": "Schweißpunktzähler",
	"e009": "Gesamtzähler",
	"e010": "Austreibungsfreie Quote",
	"e011": "Datenansicht",
	"e012": "Fehler beim Abrufen der Fahrzeugmodelldaten.",
	"e013": "Schweißpunktfilter; mehrere Werte durch Kommas trennen.",
	"e014": "Schweißprogrammfilter; mehrere Werte durch Kommas trennen.",
	"e015": "Zum Kopieren klicken",
	"e016": "Nr.",
	"e017": "<p>1. Wählen Sie eine Dimension für die Abfrage der Austreibungsrate und klicken Sie anschließend auf „Suchen“.</p><p>2. Nach Auswahl von Bereich, Gerät, Fahrzeugmodell, Schweißpunkt oder Schweißprogramm können Sie zusätzlich einen Eintrag aus der linken Liste auswählen.</p><p>3. Nach Auswahl von Schweißpunkt oder Schweißprogramm können Sie Filterwerte in das Suchfeld eingeben; trennen Sie mehrere Werte durch Kommas.</p>",
	"e018": "Werk",
	"e019": "Austreibungsdatensätze",
	"e020": "Abfrage zurücksetzen",
	"e021": "Export abgeschlossen.",
	"e022": "Export der Schweißprogramme starten",
	"e023": "Schweißprogramme werden exportiert",
	"e024": "Synchronisierung starten",
	"e025": "Synchronisierung läuft",
	"e026": "Import der Schweißprogramme starten",
	"e027": "Schweißprogramme werden importiert",
	"e028": "Fehler beim Schreiben der Schweißprogramme.",
	"e029": "Start-Schweißprogramm-Nr.",
	"e030": "End-Schweißprogramm-Nr.",
	"e031": "Fahrzeug-VIN in laufende Nummer umwandeln",
	"e032": "Geben Sie den Fahrzeug-VIN-Bereich ein.",
	"e033": "Die Fahrzeug-VIN muss eine Ganzzahl sein.",
	"e034": "Der UIP-Wert muss eine Ganzzahl größer als 0 sein.",
	"e035": "<p>Die negative Filterung von Alarmbeschreibungen wird unterstützt. Beispiel: „!Strom Schweißstufe 1 über Grenzwert“ schließt Datensätze mit „Strom Schweißstufe 1 über Grenzwert“ aus.</p>",
	"e036": "Kurve enthalten",
	"e037": "Aufzeichnung läuft",
	"e038": "Aufzeichnung nicht gestartet",
	"e039": "Vorschweißen (kA/ms)",
	"e040": "Nachschweißen (kA/ms)",
	"e041": "Kurvendaten",
	"e042": "Historische Kurven durchsuchen",
	"e043": "Die hochgeladene Datei enthält keine Schweißdatensätze.",
	"e044": "Datensätze erfolgreich durchsucht.",
	"e045": "Vorschweißstrom-Sollwert",
	"e046": "Stromsollwert Schweißstufe 1",
	"e047": "Stromsollwert Schweißstufe 2",
	"e048": "Stromsollwert Schweißstufe 3",
	"e049": "Nachschweißstrom-Sollwert",
	"e050": "Mindeststrom-Sollwert Schweißstufe 1",
	"e051": "Maximalstrom-Sollwert Schweißstufe 1",
	"e052": "Mindeststrom-Sollwert Schweißstufe 2",
	"e053": "Maximalstrom-Sollwert Schweißstufe 2",
	"e054": "Mindeststrom-Sollwert Schweißstufe 3",
	"e055": "Maximalstrom-Sollwert Schweißstufe 3",
	"e056": "Sollwert der Impulsanzahl Schweißstufe 2",
	"e057": "Kurven exportieren",
	"e058": "Exportoptionen",
	"e059": "Wählen Sie die aus den Schweißdatensätzen zu exportierende Datei aus.",
	"e060": "Der aktuelle Datensatz enthält keine Kurve.",
	"e061": "Ungültige übermittelte Parameter.",
	"e062": "Dienstfehler.",
	"e063": "Fehler beim Schreiben der Kommunikationsparameter.",
	"e064": "Stapelweise löschen",
	"e065": "Wählen Sie die zu löschenden Schweißpunkte aus.",
	"e066": "Als Bild speichern",
	"a001": "Manuell",
	"a002": "Standalone",
	"a003": "Taktzeit",
	"a004": "Sekunden",
	"a005": "Vorpressen",
	"a006": "Druckaufbau",
	"a007": "Abblasen",
	"a008": "Schweißen",
	"a009": "Aktive Schweißprogramm-Nr.",
	"a010": "Schweißprogramm-Sollwert",
	"a011": "Schweißprogrammbeschreibung",
	"a012": "Gesamtstückzahl",
	"a013": "Produktionsmenge",
	"a014": "Schweißstrom",
	"a015": "Elektrodenlebensdauer",
	"a016": "Schweißkraft",
	"a017": "Aufschmelzschwelle",
	"a018": "Verbleibende Schweißpunktanzahl",
	"a019": "Maximalwert",
	"a020": "Minimalwert",
	"a021": "Vorschweißweg",
	"a022": "Nachschweißweg",
	"a023": "Not-Halt (Öffner)",
	"a024": "Druckluftdruckalarm (Öffner)",
	"a025": "Kühlwasseralarm",
	"a026": "Wasserdurchflussalarm (Öffner)",
	"a027": "Türkettenschalter",
	"a028": "Wassertemperaturalarm",
	"a029": "Sicherheitslichtvorhang",
	"a030": "Fern-Not-Halt",
	"a031": "Hochspannungsschützrückmeldung",
	"a032": "Einzelteil-Schweißpunktzähler zurücksetzen",
	"a033": "Sicherheitsventilrückmeldung",
	"a034": "Fehlschweißungsrücksetzung",
	"a035": "Hand/Automatik",
	"a036": "Einzelbetrieb/Verbund",
	"a037": "Prüfen/Einschalten",
	"a038": "Zweihandstart 2",
	"a039": "Zweihandstart 1",
	"a040": "Fußschalterstart",
	"a041": "Einhandstart",
	"a042": "Bewegungselektrode 2 Grundstellung",
	"a043": "Bewegungselektrode 1 Grundstellung",
	"a044": "Bewegungselektrode 2 Endlage",
	"a045": "Bewegungselektrode 1 Endlage",
	"a046": "Festelektrode 2 Positionierstift ausfahren",
	"a047": "Festelektrode 1 Positionierstift ausfahren",
	"a048": "Festelektrode 2 Positionierstift zurückziehen",
	"a049": "Festelektrode 1 Positionierstift zurückziehen",
	"a050": "Förderer 1 Zuführung abgeschlossen",
	"a051": "Förderer 1 Sammelalarm",
	"a052": "Förderer 1 Förderstab Grundstellung",
	"a053": "Förderer 1 Materialmangelalarm",
	"a054": "Förderer 1 Förderstab Endlage",
	"a055": "Förderer 1 Hubzylinder Grundstellungsalarm",
	"a056": "Förderer 1 Hubzylinder Endlagenalarm",
	"a057": "Förderer 2 Zuführung abgeschlossen",
	"a058": "Förderer 2 Sammelalarm",
	"a059": "Förderer 2 Förderstab Grundstellung",
	"a060": "Förderer 2 Materialmangelalarm",
	"a061": "Förderer 2 Förderstab Endlage",
	"a062": "Förderer 2 Hubzylinder Grundstellungsalarm",
	"a063": "Förderer 2 Hubzylinder Endlagenalarm",
	"a064": "Förderer 3 Zuführung abgeschlossen",
	"a065": "Förderer 3 Sammelalarm",
	"a066": "Förderer 3 Förderstab Grundstellung",
	"a067": "Förderer 3 Materialmangelalarm",
	"a068": "Förderer 3 Förderstab Endlage",
	"a069": "Förderer 3 Hubzylinder Grundstellungsalarm",
	"a070": "Förderer 3 Hubzylinder Endlagenalarm",
	"a071": "Förderer 4 Zuführung abgeschlossen",
	"a072": "Förderer 4 Sammelalarm",
	"a073": "Förderer 4 Förderstab Grundstellung",
	"a074": "Förderer 4 Materialmangelalarm",
	"a075": "Förderer 4 Förderstab Endlage",
	"a076": "Förderer 4 Hubzylinder Grundstellungsalarm",
	"a077": "Förderer 4 Hubzylinder Endlagenalarm",
	"a078": "Hauptauslassventil",
	"a079": "Dreifarbenleuchte Summer",
	"a080": "Haupteinlassventil",
	"a081": "Dreifarbenleuchte (Grün)",
	"a082": "Bewegungselektrode 1 Verstärkerventil",
	"a083": "Dreifarbenleuchte (Gelb)",
	"a084": "Bewegungselektrode 2 Verstärkerventil",
	"a085": "Dreifarbenleuchte (Rot)",
	"a086": "Festelektrode 1 Abblasventil",
	"a087": "Bewegungselektrode 1 Druckaufbauventil",
	"a088": "Bewegungselektrode 1 Hilfshubventil (Einfachmagnetventil)",
	"a089": "Bewegungselektrode 1 Vorpressventil (Einfachmagnetventil)",
	"a090": "Bewegungselektrode 1 Hilfshubventil kleine Öffnung (Doppelmagnetventil)",
	"a091": "Bewegungselektrode 1 Aufwärtsfahrt (Doppelmagnetventil)",
	"a092": "Bewegungselektrode 1 Hilfshubventil große Öffnung (Doppelmagnetventil)",
	"a093": "Bewegungselektrode 1 Abwärtsfahrt (Doppelmagnetventil)",
	"a094": "Festelektrode 2 Abblasventil",
	"a095": "Bewegungselektrode 2 Druckaufbauventil",
	"a096": "Bewegungselektrode 2 Hilfshubventil (Einfachmagnetventil)",
	"a097": "Bewegungselektrode 2 Vorpressventil (Einfachmagnetventil)",
	"a098": "Bewegungselektrode 2 Hilfshubventil kleine Öffnung (Doppelmagnetventil)",
	"a099": "Bewegungselektrode 2 Aufwärtsfahrt (Doppelmagnetventil)",
	"a100": "Bewegungselektrode 2 Hilfshubventil große Öffnung (Doppelmagnetventil)",
	"a101": "Bewegungselektrode 2 Abwärtsfahrt (Doppelmagnetventil)",
	"a102": "Förderer 1 Rückstellung",
	"a103": "Förderer 1 Start",
	"a104": "Förderer 2 Rückstellung",
	"a105": "Förderer 2 Start",
	"a106": "Förderer 3 Rückstellung",
	"a107": "Förderer 3 Start",
	"a108": "Förderer 4 Rückstellung",
	"a109": "Förderer 4 Start",
	"a110": "Festelektrode 1 Positionierstiftventil",
	"a111": "Festelektrode 2 Positionierstiftventil",
	"a112": "Kühlwasserschalter",
	"a113": "Entladungsanforderung",
	"a114": "Sicherheitsschutz",
	"a115": "Hardwarekonfiguration",
	"a116": "Funktionskonfiguration",
	"a117": "Kommunikationskonfiguration",
	"a118": "Kalibrierung",
	"a119": "Systeminformationen",
	"a120": "Schaltschranktür",
	"a121": "Druckluftversorgungsdruck",
	"a122": "Lichtgitter",
	"a123": "Wasserdurchfluss",
	"a124": "Summer",
	"a125": "Dreifarbenleuchte",
	"a126": "Tasten/Schalter",
	"a127": "Fußschalter",
	"a128": "Einhand",
	"a129": "Zweihand",
	"a130": "Pneumatik",
	"a131": "Zuluftmagnetventil",
	"a132": "Proportionalventil",
	"a133": "Vordruckventil",
	"a134": "Druckmagnetventil",
	"a135": "Blasmagnetventil",
	"a136": "Wege-Magnetventil",
	"a137": "Kraftverstärkungsmagnetventil",
	"a138": "Gemeinsames Proportionalventil für Vor- und Hauptdruck",
	"a139": "Getrenntes Proportionalventil für Vor- und Hauptdruck",
	"a140": "Manuelle Vordruckregelung + Druck-Proportionalventil",
	"a141": "Keine Änderung",
	"a142": "Wasserkreislauf",
	"a143": "Wassereinlass-Magnetventil",
	"a144": "Wasserauslass-Magnetventil",
	"a145": "Wasserkühler",
	"a146": "Positionsschalter",
	"a147": "Bewegungselektrode Grundstellung",
	"a148": "Bewegungselektrode Endlage",
	"a149": "Positionierstift ausfahren",
	"a150": "Positionierstift zurückziehen",
	"a151": "Sensor",
	"a152": "Encoder-Wegmessung",
	"a153": "Laser-Wegmessung",
	"a154": "Wassertemperaturüberwachung",
	"a155": "Elektrodenkraft",
	"a156": "Nicht bestückt",
	"a157": "Druckluftdrucksensor",
	"a158": "Wägezelle",
	"a159": "Keine Konfigurationsänderungen, Speichern nicht möglich.",
	"a160": "Förderer",
	"a161": "Förderer 1",
	"a162": "Förderer 2",
	"a163": "Fördergut",
	"a164": "Zuführungsart",
	"a165": "Förderrichtung",
	"a166": "Steuerung",
	"a167": "Typ",
	"a168": "Schnittstelle",
	"a169": "Automatische Rückstellung in Grundstellung",
	"a170": "Halten in Endlage",
	"a171": "Zuführung zur Festelektrode",
	"a172": "Zuführung zur Bewegungselektrode",
	"a173": "Mutter",
	"a174": "Schraube",
	"a175": "Kommunikation",
	"a176": "Kommunikation (Echtzeitdaten) + IO (Start/Stopp, Rücksetzung, kritische Status, Programmnummer usw.)",
	"a177": "Positionierstift",
	"a178": "Bewegungselektrode",
	"a179": "Magnetventil",
	"a180": "Baudrate",
	"a181": "HRC803-Adresse",
	"a182": "Subnetzmaske",
	"a183": "Gateway",
	"a184": "Signalinteraktion",
	"a185": "Startmodus Einzelbetrieb",
	"a186": "Startsignal widerrufbar",
	"a187": "Signaltyp Schweißzyklusende",
	"a188": "Automatische Rückstellung bei Erreichen der Schweißpunktanzahl pro Werkstück",
	"a189": "Druck",
	"a190": "Druckeinheit",
	"a191": "Einschaltschwelle Kraftverstärkung",
	"a192": "Zeit",
	"a193": "Intervallzeit Dauerbetrieb",
	"a194": "Automatische Ausschaltzeit Kühlwasserkühler",
	"a195": "Zweihandstart",
	"a196": "Build-Zeit",
	"a197": "UI-Version",
	"a198": "Alle",
	"a199": "Fräsen oder Prüfen",
	"a200": "Gerät: {{.a}} erfolgreich verbunden",
	"a201": "Gerät: {{.a}} erfolgreich getrennt",
	"a202": "Verbinden/Trennen",
	"a203": "Schweißdaten-Push aktivieren"
}